import React, { Component } from 'react';
import service from '../services/graphQlServices';
import * as TenantsAction from './actions';
import axios from 'axios';
// import * as Actions from './actions';
import _ from 'lodash';
import moment from 'moment';
import { gql } from '@apollo/client';

import { toast } from 'react-toastify';
import TenantUsersController from './tenantUsers';
import { async } from 'q';
var randomize = require('randomatic');
class ProjectsGraphQl extends TenantUsersController {
	checkUserLoggedIn = () => {
		if (!localStorage.getItem('usertoken')) {
			window.open('https://vendors.huemn.com', '_self');
		}
	};
	getShootsCalendar = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let eventsCalendar = response[1].data.eventsCalendar.events;
			let startDate;
			let endDate;
			if (_.size(eventsCalendar) > 0) {
				startDate = eventsCalendar[0].date;
				endDate = eventsCalendar[_.size(eventsCalendar) - 1].date;
			}
			if (_.has(response[1].data.eventsCalendar, 'workspaces')) {
				let workspacesFilters = [];
				let workspacesOptions = [];
				workspacesFilters = _.map(response[1].data.eventsCalendar.workspaces, (item) => {
					return {
						key: item._id,
						name: item.workspaceId,
					};
				});
				workspacesOptions = _.map(response[1].data.eventsCalendar.workspaces, (item) => {
					return {
						value: item._id,
						label: item.workspaceId,
					};
				});

				this.setState({
					workspacesFilters,
					workspacesOptions,
				});
			}

			// if (_.has(response[1].data.eventsCalendar, 'eventCategories')) {
			// 	let categoriesFilters = [];
			// 	let categoriesOptions = [];
			// 	categoriesFilters = _.map(
			// 		response[1].data.eventsCalendar.eventCategories,
			// 		(item) => {
			// 			return {
			// 				key: item.category,
			// 				name: item.category,
			// 			};
			// 		},
			// 	);
			// 	categoriesOptions = _.map(
			// 		response[1].data.eventsCalendar.eventCategories,
			// 		(item) => {
			// 			return {
			// 				value: item.category,
			// 				label: item.category,
			// 			};
			// 		},
			// 	);

			// 	this.setState({
			// 		categoriesFilters,
			// 		categoriesOptions,
			// 		isFirstLoad: false,
			// 	});
			// }

			if (_.has(response[1].data.eventsCalendar, 'eventsMonthly')) {
				response[1].data.eventsCalendar.eventsMonthly.forEach((obj) => {
					if (obj.workspaceId === 'loveco') {
						obj.workspaceId = 'collective';
					}
				});
				// accepted;

				let cityHeatMap = {
					heatMap: [],
					absoluteMax: 0,
					rowWiseMax: [0, 0, 0, 0], //1st HYD, 2nd BLR, 3rd DEL, 4th CHE
					columnWiseMax: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], //1st apr, 2nd may and so on
				};

				let tempHeatMap = {
					heatMap: [],
					absoluteMax: 0,
					rowWiseMax: [], //1st HYD, 2nd BLR, 3rd DEL, 4th CHE
					columnWiseMax: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], //1st apr, 2nd may and so on
					workspaces: [],
				};
				let workspaceHeatmap = [];
				for (let i = 0; i < _.size(this.state.cities); i++) {
					workspaceHeatmap.push(_.cloneDeep(tempHeatMap));
				}

				for (let i = 0; i < _.size(this.state.cities); i++) {
					cityHeatMap.heatMap[i] = [];
					for (let j = 0; j < _.size(this.state.monthsList); j++) {
						cityHeatMap.heatMap[i][j] = 0;
					}
				}
				_.forEach(response[1].data.eventsCalendar.eventsMonthly, (item, index) => {
					if (_.has(item, 'city')) {
						let cityMapToNum = this.state.cityMapToNum.get(item.city);
						let monthMapToNum = this.state.monthsListMapToNum.get(
							`${item.month}`.slice(4),
						);

						let found = -1;
						found = _.findIndex(
							workspaceHeatmap[cityMapToNum].workspaces,
							(wkId) => wkId === item.workspaceId,
						);
						if (found === -1) {
							workspaceHeatmap[cityMapToNum].workspaces.push(item.workspaceId);
						}

						cityHeatMap.heatMap[cityMapToNum][monthMapToNum] += item.count;
					}
				});

				for (let i = 0; i < _.size(cityHeatMap.heatMap); i++) {
					for (let j = 0; j < _.size(cityHeatMap.heatMap[i]); j++) {
						if (cityHeatMap.heatMap[i][j] > cityHeatMap.absoluteMax) {
							cityHeatMap.absoluteMax = cityHeatMap.heatMap[i][j];
						}

						if (cityHeatMap.heatMap[i][j] > cityHeatMap.rowWiseMax[i]) {
							cityHeatMap.rowWiseMax[i] = cityHeatMap.heatMap[i][j];
						}
						if (cityHeatMap.heatMap[i][j] > cityHeatMap.columnWiseMax[j]) {
							cityHeatMap.columnWiseMax[j] = cityHeatMap.heatMap[i][j];
						}
					}
				}

				for (let i = 0; i < _.size(workspaceHeatmap); i++) {
					for (let j = 0; j < _.size(workspaceHeatmap[i].workspaces); j++) {
						workspaceHeatmap[i].heatMap[j] = [];
						workspaceHeatmap[i].rowWiseMax[j] = 0;
						for (let k = 0; k < _.size(this.state.monthsList); k++) {
							workspaceHeatmap[i].heatMap[j][k] = 0;
						}
					}
				}

				_.forEach(response[1].data.eventsCalendar.eventsMonthly, (item, index) => {
					if (_.has(item, 'city')) {
						let cityMapToNum = this.state.cityMapToNum.get(item.city);
						let monthMapToNum = this.state.monthsListMapToNum.get(
							`${item.month}`.slice(4),
						);
						let workspaceMapToNum = _.findIndex(
							workspaceHeatmap[cityMapToNum].workspaces,
							(wkId) => wkId === item.workspaceId,
						);

						workspaceHeatmap[cityMapToNum].heatMap[workspaceMapToNum][monthMapToNum] +=
							item.count;
					}
				});

				for (let k = 0; k < _.size(workspaceHeatmap); k++) {
					for (let i = 0; i < _.size(workspaceHeatmap[k].heatMap); i++) {
						for (let j = 0; j < _.size(workspaceHeatmap[k].heatMap[i]); j++) {
							if (
								workspaceHeatmap[k].heatMap[i][j] > workspaceHeatmap[k].absoluteMax
							) {
								workspaceHeatmap[k].absoluteMax = workspaceHeatmap[k].heatMap[i][j];
							}

							if (
								workspaceHeatmap[k].heatMap[i][j] >
								workspaceHeatmap[k].rowWiseMax[i]
							) {
								workspaceHeatmap[k].rowWiseMax[i] =
									workspaceHeatmap[k].heatMap[i][j];
							}
							if (
								workspaceHeatmap[k].heatMap[i][j] >
								workspaceHeatmap[k].columnWiseMax[j]
							) {
								workspaceHeatmap[k].columnWiseMax[j] =
									workspaceHeatmap[k].heatMap[i][j];
							}
						}
					}
				}
				let allBranchAbsMax = 0;
				for (let k = 0; k < _.size(workspaceHeatmap); k++) {
					if (workspaceHeatmap[k].absoluteMax > allBranchAbsMax) {
						allBranchAbsMax = workspaceHeatmap[k].absoluteMax;
					}
				}

				for (let i = 0; i < _.size(workspaceHeatmap); i++) {
					workspaceHeatmap[i].allBranchAbsMax = allBranchAbsMax;
				}
				/* Accepted Proposals Heat Map Calculations */
				let absArray = [];
				for (let i = 0; i < 12; i++) {
					let absColmax = 0;
					for (let j = 0; j < _.size(workspaceHeatmap); j++) {
						if (workspaceHeatmap[j].columnWiseMax[i] > absColmax) {
							absColmax = workspaceHeatmap[j].columnWiseMax[i];
						}
					}
					absArray.push(absColmax);
				}
				for (let i = 0; i < _.size(workspaceHeatmap); i++) {
					workspaceHeatmap[i].absArray = absArray;
				}
				let brandOrder = [
					[
						'vijayeesam',

						'collective',
						'wedberry',
						'onelovefilms',
						'foreverbygayathri',
						'twobeats',
						'day1story',
						'dreamdaystudios',
						'magica',
						'atomcontent',
					],
					['bengaluruweddingcompany', 'balladsoflove', 'lagna', 'karwaan'],
					['falaknamafilms', 'thedelhiweddingcompany', 'highonlove'],
					['magnum'],
					['dummyhuemn'],
				];
				let resIndArray = [];
				for (let i = 0; i < _.size(workspaceHeatmap); i++) {
					let indArray = Array(_.size(brandOrder[i])).fill(-1);
					for (let j = 0; j < _.size(brandOrder[i]); j++) {
						for (let k = 0; k < _.size(workspaceHeatmap[i].workspaces); k++) {
							//here have to add a logic if the particular brand in brand order exists within the workspaceHeatmap[i].workspaces or not
							//if does then do this ->
							if (workspaceHeatmap[i].workspaces[k] === brandOrder[i][j]) {
								indArray[j] = k;
							}
							//else push -1 to resindArray
						}
					}
					resIndArray.push(indArray);
				}
				for (let j = 0; j < 4; j++) {
					// now while going through this for whatever index in resIndArray we are getting the value as -1 , there push every value as 0
					//if not then apply the logic below
					for (let i = 0; i < _.size(resIndArray[j]); i++) {
						if (resIndArray[j][i] === -1) {
							workspaceHeatmap[j].heatMap.push([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
							workspaceHeatmap[j].rowWiseMax.push(0);

							workspaceHeatmap[j].workspaces.push('');
						}
					}
				}
				let dupWorkspaceHeatmap = _.cloneDeep(workspaceHeatmap);

				for (let j = 0; j < 4; j++) {
					// now while going through this for whatever index in resIndArray we are getting the value as -1 , there push every value as 0
					//if not then apply the logic below
					for (let i = 0; i < _.size(resIndArray[j]); i++) {
						if (resIndArray[j][i] === -1) {
							// workspaceHeatmap[j].heatMap[i] = 0;
							workspaceHeatmap[j].heatMap[i] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
							workspaceHeatmap[j].rowWiseMax[i] = 0;

							workspaceHeatmap[j].workspaces[i] = brandOrder[j][i];
						} else {
							workspaceHeatmap[j].heatMap[i] =
								dupWorkspaceHeatmap[j].heatMap[resIndArray[j][i]];
							workspaceHeatmap[j].rowWiseMax[i] =
								dupWorkspaceHeatmap[j].rowWiseMax[resIndArray[j][i]];

							workspaceHeatmap[j].workspaces[i] =
								dupWorkspaceHeatmap[j].workspaces[resIndArray[j][i]];
						}
					}
				}

				let allCityMonthCounts = [];
				let allBrandCounts = [];
				for (let i = 0; i < _.size(workspaceHeatmap); i++) {
					let tempArray = [];
					for (let j = 0; j < _.size(workspaceHeatmap[i].heatMap); j++) {
						for (let k = 0; k < _.size(workspaceHeatmap[i].heatMap[j]); k++) {
							allCityMonthCounts.push(workspaceHeatmap[i].heatMap[j][k]);
							tempArray.push(workspaceHeatmap[i].heatMap[j][k]);
						}
					}
					allBrandCounts.push(tempArray);
				}
				let allCityData = [];
				for (let i = 0; i < cityHeatMap.heatMap.length; i++) {
					for (let j = 0; j < _.size(cityHeatMap.heatMap[i]); j++) {
						allCityData.push(cityHeatMap.heatMap[i][j]);
					}
				}
				let allMonthDataArray = [];
				for (let i = 0; i < _.size(workspaceHeatmap); i++) {
					let temparray = [];
					for (let j = 0; j < _.size(workspaceHeatmap[i].heatMap); j++) {
						temparray.push(workspaceHeatmap[i].heatMap[j]);
					}
					allMonthDataArray.push(temparray);
				}

				let resColData = [];
				for (let k = 0; k < _.size(allMonthDataArray); k++) {
					let tempArray = [];
					const rows = allMonthDataArray[k].length;
					const cols = allMonthDataArray[k][0]?.length;
					const transposedData = [];

					for (let i = 0; i < cols; i++) {
						transposedData.push([]);
						for (let j = 0; j < rows; j++) {
							transposedData[i].push(allMonthDataArray[k][j][i]);
						}
					}
					resColData.push(transposedData);
				}

				const rows = cityHeatMap.heatMap.length;
				const cols = cityHeatMap.heatMap[0].length;
				const resCityColData = [];

				for (let i = 0; i < cols; i++) {
					resCityColData.push([]);
					for (let j = 0; j < rows; j++) {
						resCityColData[i].push(cityHeatMap.heatMap[j][i]);
					}
				}

				const mergedData = [];
				for (let i = 0; i < resColData[0].length; i++) {
					const mergedColumn = [];
					for (let j = 0; j < resColData.length; j++) {
						if (resColData[j][i]) mergedColumn.push(...resColData[j][i]);
					}
					mergedData.push(mergedColumn);
				}

				this.setState({
					workspaceHeatmap,
					allMonthDataArray,
					mergedData,
					resIndArray,
					allCityMonthCounts: [...allCityMonthCounts],
					allBrandCounts: allBrandCounts,
					resColData,
					resCityColData,

					cityHeatMap,
					allCityData,
					// isHeatMapLoading: false,
				});
			}

			this.setState({
				eventsCalendar,
				startDate,
				endDate,
				isLoading: false,
				isPageLoading: false,
			});
		}
	};
	getEquipmentList = async (query, variables, isFirstLoad = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let tenantUsersList;

			let projectFilters = [];

			if (_.has(response[1].data, 'vendorTenantUsersList')) {
				let list = response[1].data.vendorTenantUsersList.data;
				if (_.size(list) > 0) {
					let arr = [];
					_.forEach(list, (item, key) => {
						if (item.isEmailVerified === true) {
							arr.push({
								key: item.id,
								name: item.displayName
									? item.displayName
									: item.firstName + ' ' + item.lastName,
							});
						}
					});
					tenantUsersList = arr;
				} else {
					tenantUsersList = [];
				}

				this.setState({
					tenantUsersList,
					userHasNextPage: response[1].data.vendorTenantUsersList.hasNextPage,
				});
			}

			if (
				_.has(response[1].data, 'vendorsProjects') &&
				_.size(response[1].data.vendorsProjects) > 0
			) {
				let arr = [];
				_.forEach(response[1].data.vendorsProjects.data, (item, key) => {
					arr.push({
						key: item.id,
						name: item.title === null ? '' : item.title,
					});
				});
				projectFilters = arr;

				this.setState({
					projectFilters,
				});
			}

			if (_.has(response[1].data, 'branchesList')) {
				let branchIdsFilters = [];
				branchIdsFilters = _.map(response[1].data.branchesList, (item) => {
					return {
						key: item.branchId,
						name: item.branchId,
					};
				});
				this.setState({
					branchIdsFilters,
				});
			}

			if (_.has(response[1].data, 'equipmentSummary')) {
				let arr = [];
				let camera = _.find(response[1].data.equipmentSummary, {
					type: 'camera',
				});
				let lens = _.find(response[1].data.equipmentSummary, {
					type: 'lens',
				});

				if (camera && _.size(camera) > 0) {
					arr.push(camera);
				}

				if (lens && _.size(lens) > 0) {
					arr.push(lens);
				}

				_.forEach(response[1].data.equipmentSummary, (item, index) => {
					if (item.type !== 'camera' && item.type !== 'lens') {
						arr.push(item);
					}
				});

				let summaryData = [];

				_.forEach(arr, (item, index) => {
					let mainObj = {
						isExpanded: false,
						type: item.type,
						total: item.typeCount,
						readyCount: 0,
						assignedCount: 0,
						typeModels: {},
					};
					_.forEach(item.models, (model, inx) => {
						let modelKey = model.model !== null ? model.model : 'Unknown model';
						if (!_.has(mainObj.typeModels, modelKey)) {
							mainObj.typeModels[modelKey] = {
								busy: 0,
								ready: 0,
							};
						}

						if (model.status === 'ready') {
							mainObj.readyCount += model.count;
						} else if (model.status === 'busy') {
							mainObj.assignedCount += model.count;
						}

						mainObj.typeModels[modelKey][model.status] += model.count;
					});

					summaryData.push(mainObj);
				});

				if (isFirstLoad === true) {
					let typesFilters = [];

					typesFilters = _.map(summaryData, (eq) => {
						return {
							key: eq.type,
							name:
								eq.type.charAt(0).toUpperCase() +
								eq.type.replace(/([A-Z])/g, ' $1').slice(1),
						};
					});
					this.setState({
						typesFilters,
					});
				}
				this.setState({
					isLoading: false,
					equipmentSummary: summaryData,
				});
			}

			this.setState({
				equipmentList: response[1].data.equipmentList.data,
				totalPages: response[1].data.equipmentList.totalPages,
				currentViewPage: response[1].data.equipmentList.currentPage,
				lengthOfList: response[1].data.equipmentList.totalDocs,
				isPageLoading: false,
				isLoading: false,
			});
		} else {
		}
	};

	getVendorProjects = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let projectsOptions = [];
			projectsOptions = _.map(response[1].data.vendorsProjects.data, (item) => {
				return {
					value: item.id,
					label: item.title,
				};
			});
			this.setState({
				isProjectsLoading: false,
				projectsOptions,
			});
		} else {
		}
	};

	getVendorsProjectDetails = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let tenantUsersList = response[1].data.vendorUsers;
			response[1].data.vendorsProject.events = _.map(
				response[1].data.vendorsProject.events,
				(event) => {
					event.crewDetails = [];
					_.map(event.crewNew, (crew) => {
						if (crew.isCustomUser !== true) {
							_.forEach(crew.roles, (roles) => {
								let dateOverlap = false;
								let dateTimeOverlap = false;
								let name = '';
								let isManager;
								let role = null;
								let subRole = null;
								let displayName = '';
								let isSuspended = false;
								let isShooter = false;
								let found = undefined;
								if (crew.userId === null) {
								} else {
									found = _.find(tenantUsersList, { id: crew.userId });
								}

								if (found) {
									name = `${found.firstName ? found.firstName : ''}${' '}${
										found.lastName ? found.lastName : ''
									}`;
									role = roles.role;
									isManager = crew.isManager === null ? false : crew.isManager;
									subRole = roles.subRole;
									displayName =
										_.has(found, 'displayName') && found.displayName
											? found.displayName
											: '';
									isShooter = found.isShooter;
									isSuspended = found.isSuspended;
								} else {
									name = 'unassigned';
									role = roles.role;
									isManager = false;
									subRole = roles.subRole;
									displayName = 'unassigned';
									isShooter = false;
									isSuspended = false;
								}

								if (crew.userId !== null) {
									found = undefined;
									found = _.find(event.dateOverlap, (value, key) => {
										return value === crew.userId;
									});
									if (found) {
										dateOverlap = true;
									}
									found = undefined;
									found = _.find(event.dateTimeOverlap, (value, key) => {
										return value === crew.userId;
									});
									if (found) {
										dateTimeOverlap = true;
									}
								}
								let data = {
									name,
									dateOverlap,
									dateTimeOverlap,
									isManager,
									role,
									subRole,
									displayName,
									isShooter,
									isSuspended,
								};
								event.crewDetails.push(data);
							});
						}
						return crew;
					});
					return event;
				},
			);

			if (_.has(response[1].data, 'vendorUsers')) {
				let list = response[1].data.vendorUsers;
				if (_.size(list) > 0) {
					let arr = [];
					_.forEach(list, (item, key) => {
						if (item.isEmailVerified === true) {
							arr.push({
								key: item.id,
								name: ` ${
									item.displayName !== null
										? `${item.displayName}`
										: `${item.firstName} ${item.lastName}`
								}`,
								isShooter: item.isShooter,
								isSuspended: item.isSuspended,
								phoneNumber: item.phoneNumber,
								accessibleTenants: item.accessibleTenants,
							});
						}
					});
					tenantUsersList = arr;
				} else {
					tenantUsersList = [];
				}

				this.setState({
					tenantUsersList,
					vendorUsers: response[1].data.vendorUsers,
				});
			}
			this.setState({
				isLoading: false,
				projectDetails: response[1].data.vendorsProject,
			});
		} else {
		}
	};

	getEventsCitiesList = async (query) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, {}, vendorID, usertoken, 'vendors');

		if (response[0] === true) {
			if (_.has(response[1].data, 'eventsCityList')) {
				let cityFilters = [];
				cityFilters = _.map(response[1].data.eventsCityList, (item) => {
					return {
						key: item,
						name: _.capitalize(item),
					};
				});
				this.setState({
					cityFilters,
				});
			}
		}
	};

	getVendorEventsList = async (query, variables, isMultiple = null, totalMultiplePages = 0) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let tenantUsersList = _.has(response[1].data, 'vendorUsers')
				? response[1].data.vendorUsers
				: this.state.tenantUsersOGList;

			if (_.has(response[1].data, 'vendorUsers'))
				this.setState({
					tenantUsersOGList: response[1].data.vendorUsers,
				});

			let tempVendorEventsList = [];
			_.forEach(response[1].data.vendorEventsList.data, (event, key) => {
				//event.crewDetails = [];
				let tempEvent = { ...event, crewDetails: [], crewNew: [] };
				_.forEach(event.crewNew, (crew) => {
					if (crew.isCustomUser === false) {
						_.forEach(crew.roles, (roles) => {
							let dateOverlap = false;
							let dateTimeOverlap = false;
							let name = '';
							let isManager;
							let role = null;
							let subRole = null;
							let displayName = '';
							let found = undefined;

							if (crew.userId === null) {
							} else {
								found = _.find(tenantUsersList, { id: crew.userId });
							}

							if (found) {
								name = `${found.firstName ? found.firstName : ''}${' '}${
									found.lastName ? found.lastName : ''
								}`;
								role = roles.role;
								isManager = crew.isManager === null ? false : crew.isManager;
								subRole = roles.subRole;
								displayName =
									_.has(found, 'displayName') && found.displayName
										? found.displayName
										: '';
							} else if (crew.userId === null) {
								name = 'unassigned';
								role = roles.role;
								isManager = false;
								subRole = roles.subRole;
								displayName = 'unassigned';
							} else {
								name = 'User unknown';
								role = roles.role;
								isManager = false;
								subRole = roles.subRole;
								displayName = 'User unknown';
							}

							// found = undefined
							// found = _.find(
							//     event.dateTimeOverlap,
							//     (value, key) => {
							//         return value === userId
							//     }
							// )
							// if (found) {
							//     dateTimeOverlap = true
							// }

							let data = {
								name,
								dateOverlap,
								dateTimeOverlap,
								isManager,
								role,
								subRole,
								displayName,
								id: crew.userId,
							};
							tempEvent.crewDetails.push(data);
						});
						tempEvent.crewNew.push(crew);
					}
				});
				tempVendorEventsList.push(tempEvent);
			});

			response[1].data.vendorEventsList.data = tempVendorEventsList;

			if (_.has(response[1].data, 'vendorUsers')) {
				let list = response[1].data.vendorUsers;
				if (_.size(list) > 0) {
					let arr = [];
					_.forEach(list, (item, key) => {
						//if (item.isEmailVerified === true) {
						arr.push({
							key: item.id,
							name: item.firstName + (item.lastName ? ' ' + item.lastName : ''),
							phoneNumber: item.phoneNumber,
							isShooter: item.isShooter,
							isSuspended: item.isSuspended,
							accessibleTenants: item?.accessibleTenants,
						});
						//}
					});
					tenantUsersList = arr;
				} else {
					tenantUsersList = [];
				}

				this.setState({
					tenantUsersList,
				});
			}

			if (_.has(response[1].data, 'vendorInfo')) {
				let workspacesFilters = [];
				let workspacesOptions = [];
				workspacesFilters = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
					return {
						key: item._id,
						name: item.workspaceId,
					};
				});
				workspacesOptions = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
					return {
						value: item._id,
						label: item.workspaceId,
					};
				});

				this.setState({
					workspacesFilters,
					workspacesOptions,
					vendorInfo: response[1].data.vendorInfo,
					associatedTenants: response[1].data.vendorInfo.associatedTenants,
				});
			}

			this.setState(
				{
					shootList: [...this.state.shootList, ...response[1].data.vendorEventsList.data],
					totalPages: response[1].data.vendorEventsList.totalPages,
					currentViewPage: response[1].data.vendorEventsList.currentPage,
					lengthOfList:
						this.state.lengthOfList + _.size(response[1].data.vendorEventsList.data), //response[1].data.vendorEventsList.totalDocs
					hasNextPage: response[1].data.vendorEventsList.hasNextPage,

					isLoading: false,
					isPageLoading:
						isMultiple !== null
							? totalMultiplePages == response[1].data.vendorEventsList.currentPage
								? false
								: true
							: false,
				},
				() => {
					if (_.has(this, 'flagShootersForTheSameDay')) this.flagShootersForTheSameDay();
				},
			);
		} else {
		}
	};
	getTaskList = async (query, variables, isMultiple = null, totalMultiplePages = 0) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				// shootList: [...this.state.shootList, ...response[1].data.vendorEventsList.data],
				taskList: response[1].data.tasks.data,
				totalPages: response[1].data.tasks.totalPages,
				currentViewPage: response[1].data.tasks.currentPage,
				lengthOfList: response[1].data.tasks.totalDocs,

				hasNextPage: response[1].data.tasks.hasNextPage,

				isLoading: false,
				isPageLoading:
					isMultiple !== null
						? totalMultiplePages == response[1].data.tasks.currentPage
							? false
							: true
						: false,
			});
		} else {
		}
	};
	getEmployeesAttendanceList = async (
		query,
		variables,
		isMultiple = null,
		totalMultiplePages = 0,
	) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				// shootList: [...this.state.shootList, ...response[1].data.vendorEventsList.data],
				employeesAttendanceList: response[1].data.employeesAttendance.data,
				totalPages: response[1].data.employeesAttendance.totalPages,
				currentViewPage: response[1].data.employeesAttendance.currentPage,
				lengthOfList: response[1].data.employeesAttendance.totalDocs,

				hasNextPage: response[1].data.employeesAttendance.hasNextPage,

				isLoading: false,
				isPageLoading:
					isMultiple !== null
						? totalMultiplePages == response[1].data.employeesAttendance.currentPage
							? false
							: true
						: false,
			});
		} else {
		}
	};
	getEmployeesAttendanceCount = async (
		query,
		variables,
		isMultiple = null,
		totalMultiplePages = 0,
	) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				// shootList: [...this.state.shootList, ...response[1].data.vendorEventsList.data],
				employeesAttendanceCount: response[1].data.attendanceDefaultFilters,
			});
		} else {
		}
	};

	getWorkspaceTenantUsers = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let tenantUsersList = [];
			let list = response[1].data.tenantUsersList;
			if (_.size(list) > 0) {
				let arr = [];
				_.forEach(list, (item, key) => {
					//if (item.isEmailVerified === true) {
					arr.push({
						key: item.id,
						name: item.firstName + (item.lastName ? ' ' + item.lastName : ''),
						phoneNumber: item.phoneNumber,
					});
					//}
				});
				tenantUsersList = arr;
			} else {
				tenantUsersList = [];
			}

			this.setState({
				isWorkspaceTenantUsersLoading: false,
				tenantUsersList,
			});
			return tenantUsersList;
		} else {
			return false;
		}
	};

	getVendorTenantUsersList = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			response[1].data.vendorTenantUsersList.data = _.filter(
				response[1].data.vendorTenantUsersList.data,
				{
					isEmailVerified: true,
				},
			);

			if (_.has(response[1].data, 'vendorInfo')) {
				let workspacesFilters = [];
				workspacesFilters = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
					return {
						key: item.workspaceId,
						name: item.workspaceId,
					};
				});

				this.setState({
					workspacesFilters,
					vendorInfo: response[1].data.vendorInfo,
				});
			}

			let arr = [];
			_.forEach(response[1].data.vendorTenantUsersList.data, (item, key) => {
				item.fullName = `${item.firstName}${' '}${
					item.lastName == null ? '' : item.lastName
				}`;
				return arr.push(item);
			});
			response[1].data.vendorTenantUsersList.data = arr;
			let columns = this.state.columns;
			if (_.has(response[1].data, 'vendorInfo')) {
				_.map(response[1].data.vendorInfo.associatedTenants, (ws, key) => {
					columns.push({
						title: ws.workspaceKey,
						className: 'wedding-details-column',
						workspaceId: ws.workspaceId,
					});
				});
				this.setState({
					associatedTenants: response[1].data.vendorInfo.associatedTenants,
				});
			}
			if (_.has(response[1].data, 'branchesList')) {
				let branchIdsFilters = [];
				branchIdsFilters = _.map(response[1].data.branchesList, (item) => {
					return {
						key: item.branchId,
						name: item.branchId,
					};
				});
				this.setState({
					branchIdsFilters,
				});
			}
			this.setState({
				isLoading: false,
				tenantUsersList: response[1].data.vendorTenantUsersList.data,
				totalPages: response[1].data.vendorTenantUsersList.totalPages,
				currentViewPage: response[1].data.vendorTenantUsersList.currentPage,
				lengthOfList: response[1].data.vendorTenantUsersList.totalDocs,

				isPageLoading: false,
				columns,
			});
		} else {
		}
	};

	getVendorMCList = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let tenantUsersList;

			let projectFilters = [];

			if (_.has(response[1].data, 'vendorTenantUsersList')) {
				let list = response[1].data.vendorTenantUsersList.data;
				if (_.size(list) > 0) {
					let arr = [];
					_.forEach(list, (item, key) => {
						if (item.isEmailVerified === true) {
							arr.push({
								key: item.id,
								name: item.firstName + ' ' + item.lastName,
							});
						}
					});
					tenantUsersList = arr;
				} else {
					tenantUsersList = [];
				}

				this.setState({
					tenantUsersList,
					userHasNextPage: response[1].data.vendorTenantUsersList.hasNextPage,
				});
			}

			if (
				_.has(response[1].data, 'vendorsProjects') &&
				_.size(response[1].data.vendorsProjects.data) > 0
			) {
				let arr = [];
				_.forEach(response[1].data.vendorsProjects.data, (item, key) => {
					arr.push({
						key: item.id,
						name: item.title === null ? '' : item.title,
					});
				});
				projectFilters = arr;

				this.setState({
					projectFilters,
				});
			}

			if (_.has(response[1].data, 'branchesList')) {
				let branchIdsFilters = [];
				branchIdsFilters = _.map(response[1].data.branchesList, (item) => {
					return {
						key: item.branchId,
						name: item.branchId,
					};
				});
				this.setState({
					branchIdsFilters,
				});
			}

			if (_.has(response[1].data, 'memoryCardSummary')) {
				this.setState({
					memoryCardSummaryList: response[1].data.memoryCardSummary,
				});
			}

			this.setState({
				isLoading: false,
				mcList: response[1].data.memoryCardList.data,
				totalPages: response[1].data.memoryCardList.totalPages,
				currentViewPage: response[1].data.memoryCardList.currentPage,
				lengthOfList: response[1].data.memoryCardList.totalDocs,
				isPageLoading: false,
			});
		} else {
		}
	};
	getMemoryCardSummaryControllers = async (query, variables) => {};
	getTenantUsersList = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				isTenantsLoading: false,
				tenantUsersList: response[1].data.tenantUsersList,
			});
		}
	};
	assignEquipment = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;

		this.setState({ isAssignedEquipmentLoading: true });

		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			this.setState({ isAssignedEquipmentLoading: false });
			return response;
		} else {
			this.setState({ isAssignedEquipmentLoading: false });
			return response;
		}
	};
	assignHardDrive = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				// response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Hard Drive Assigned!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (response[1].data.assignHardDrive !== null) {
				this.setState({ message: response[1].data.assignHardDrive.message });
				this.setState({
					hardDriveInfoList: [],
					osChecked: false,
					selectedValue: {},
					note: '',
				});
			}
			this.setState({
				isAPISubmitting: false,
			});

			this.timer = setTimeout(() => {
				window.location.reload();
			}, 1000);

			// return response;
		} else {
			this.setState({
				message: 'Something went wrong',
				isAPISubmitting: false,
			});
			// return response;
		}
	};
	receiveHardDrive = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				// response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
					this.setState({
						message: response[1].data.receiveHardDrive.message,
					});
				} else {
					reject(response[1].message);
					this.setState({
						message: 'Something went wrong',
					});
				}
			}),
			{
				pending: 'Loading',
				success: `Hard Drive Received!`,
				error: `Failed to receive Hard Drive`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (response[1].data.receiveHardDrive !== null) {
				this.setState({
					message: response[1].data.receiveHardDrive.message,
					hardDriveInfoList: [],
					selectedValue: {},
					selectedValue2: {},
					note: '',
				});
			}
			this.setState({
				isAPISubmitting: false,
			});

			this.timer = setTimeout(() => {
				window.location.reload();
			}, 1000);

			// return response;
		} else {
			this.setState({
				isAPISubmitting: false,
				message: 'Something went wrong',
			});
			// return response;
		}
	};
	addEmployee = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				// response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `New member added!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (response[1].data.addEmployee !== null) {
				this.setState({ message: 'Member added' });
				this.setState({
					addEmployeeId: response[1].data.addEmployee.id,
					// firstName: '',
					// lastName: '',
					genderType: null,
					gender: '',
					dob: '',
					selectedDob: '',
					bloodGroup: '',
					selectedBloodGroup: '',
					aadharNumber: '',
					panNumber: '',
					selectedJoiningDate: '',
					employeeType: null,
					employeeTypeString: '',
					brandString: '',
					selectedBrand: null,
					department: '',
					designation: '',
					fullName: '',
					displayName: '',
					monthlySalaryPreTax: '',
					selectedBranch: '',
					branchIdString: '',
					branchId: '',
					selectedStatus: '',
					statusString: '',
					personalPhoneNumber: '',

					personalEmail: '',
					officePhoneNumber: '',
					officeEmail: '',
					currentAddress: {
						city: '',
						country: '',
						district: '',
						pinCode: '',
						state: '',
						street: '',
					},
					permanentAddress: {
						city: '',
						country: '',
						district: '',
						pinCode: '',
						state: '',
						street: '',
					},
					emergencyContact: {
						name: '',
						phoneNumber: '',
						relation: '',
					},
					bankAccountDetails: {
						IFSC: '',
						accountHolderName: '',
						accountNumber: '',
						branch: '',
						bankName: '',
					},
				});
				this.uploadProfilePicture(
					this.state.croppedFile,
					response[1].data.addEmployee.id,
				).then(() => {
					this.setState({
						imageSrc: '',
					});
				});
			}
			this.setState({
				isAPISubmitting: false,
			});

			// return response;
		} else {
			this.setState({
				message: 'Something went wrong',
				isAPISubmitting: false,
			});
			// return response; Test commit
		}
	};
	updateAsset = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				// response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `Asset updated Successfully!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		// if (response[0] == true) {
		// 	if (response[1].data.addEmployee !== null) {
		// 		this.setState({ message: 'Member added' });
		// 		this.setState({
		// 			addEmployeeId: response[1].data.addEmployee.id,
		// 			// firstName: '',
		// 			// lastName: '',
		// 			genderType: null,
		// 			gender: '',
		// 			dob: '',
		// 			selectedDob: '',
		// 			bloodGroup: '',
		// 			selectedBloodGroup: '',
		// 			aadharNumber: '',
		// 			panNumber: '',
		// 			selectedJoiningDate: '',
		// 			employeeType: null,
		// 			employeeTypeString: '',
		// 			brandString: '',
		// 			selectedBrand: null,
		// 			department: '',
		// 			designation: '',
		// 			fullName: '',
		// 			displayName: '',
		// 			monthlySalaryPreTax: '',
		// 			selectedBranch: '',
		// 			branchIdString: '',
		// 			branchId: '',
		// 			selectedStatus: '',
		// 			statusString: '',
		// 			personalPhoneNumber: '',

		// 			personalEmail: '',
		// 			officePhoneNumber: '',
		// 			officeEmail: '',
		// 			currentAddress: {
		// 				city: '',
		// 				country: '',
		// 				district: '',
		// 				pinCode: '',
		// 				state: '',
		// 				street: '',
		// 			},
		// 			permanentAddress: {
		// 				city: '',
		// 				country: '',
		// 				district: '',
		// 				pinCode: '',
		// 				state: '',
		// 				street: '',
		// 			},
		// 			emergencyContact: {
		// 				name: '',
		// 				phoneNumber: '',
		// 				relation: '',
		// 			},
		// 			bankAccountDetails: {
		// 				IFSC: '',
		// 				accountHolderName: '',
		// 				accountNumber: '',
		// 				branch: '',
		// 				bankName: '',
		// 			},
		// 		});
		// 		this.uploadProfilePicture(
		// 			this.state.croppedFile,
		// 			response[1].data.addEmployee.id,
		// 		).then(() => {
		// 			this.setState({
		// 				imageSrc: '',
		// 			});
		// 		});
		// 	}
		// 	this.setState({
		// 		isAPISubmitting: false,
		// 	});

		// 	// return response;
		// } else {
		// 	this.setState({
		// 		message: 'Something went wrong',
		// 		isAPISubmitting: false,
		// 	});
		// 	// return response; Test commit
		// }
	};
	updateTask = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `Task updated Successfully!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	};
	updateAttendance = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `Attendance updated Successfully!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	};
	assignReceiveAsset = async (query, variables, type) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `${type} Successfull!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	};
	createTask = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `Deliverable task created Successfully!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	};
	createGenTask = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `General Task created Successfully!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	};
	createWorkspaceTask = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `Workspace Task created Successfully!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	};
	createProjectTask = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `Project Task created Successfully!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	};
	registerAsset = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;

		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					if (response[1].data.addEmployee !== null) {
						this.setState({ message: 'Asset Registered Successfully' });
						this.setState({
							serialNumber: '',
							assetType: '',
							branchString: '',
							selectedassetType: {},
							selectedbranchString: {},
							qrCode: '',
							description: '',
							isAPISubmitting: false,
						});
					}
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Asset Registered!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			this.setState({
				serialNumber: '',
				assetType: '',
				branchString: '',
				selectedassetType: {},
				selectedbranchString: {},
				qrCode: '',
				description: '',
				isAPISubmitting: false,
			});

			// return response;
		} else {
			this.setState({
				errorMessage: 'Something went wrong',
				isAPISubmitting: false,
			});
			// return response;
		}
	};
	deleteAsset = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				// response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `Asset Deleted!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (response[1].data.addEmployee !== null) {
				this.setState({ message: 'Asset Deleted Successfully' });
				this.setState({
					serialNumber: '',
					assetType: '',
					branchString: '',
					selectedAssetType: {},
					selectedBranch: {},
					qrCode: '',
					description: '',
				});
			}
			this.setState({
				isAPISubmitting: false,
			});

			// return response;
		} else {
			this.setState({
				message: 'Something went wrong',
				isAPISubmitting: false,
			});
			// return response;
		}
	};
	assignAsset = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				// response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `Asset Assigned!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (response[1].data.addEmployee !== null) {
				this.setState({ message: 'Asset assigned Successfully' });
				this.setState({
					serialNumber: '',
					assetType: '',
					branchString: '',
					selectedAssetType: {},
					selectedBranch: {},
					qrCode: '',
					description: '',
				});
			}
			this.setState({
				isAPISubmitting: false,
			});

			// return response;
		} else {
			this.setState({
				message: 'Something went wrong',
				isAPISubmitting: false,
			});
			// return response;
		}
	};
	editEmployee = async (query, variables) => {
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		var response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		await toast.promise(
			new Promise(async (resolve, reject) => {
				// response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject('Something went wrong');
				}
			}),
			{
				pending: 'Loading',
				success: `Employee details added successfully!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (response[1].data.updateEmployee !== null) {
				this.setState({
					message: 'Employee details added successfully!',
					editButtonClk: false,
				});
				// this.uploadProfilePicture(this.state.croppedFile, this.state.employeeId);
				// this.setState({
				// 	firstName: '',
				// 	lastName: '',
				// 	genderType: null,
				// 	gender: '',
				// 	dob: '',
				// 	selectedDob: '',
				// 	bloodGroup: '',
				// 	aadharNumber: '',
				// 	panNumber: '',
				// 	selectedJoiningDate: '',
				// 	employeeType: null,
				// 	employeeTypeString: '',
				// 	brandString: '',
				// 	selectedBrand: null,
				// 	department: '',
				// 	designation: '',
				// 	monthlySalaryPreTax: '',
				// 	selectedBranch: '',
				// 	branchIdString: '',
				// 	branchId: '',
				// 	selectedStatus: '',
				// 	statusString: '',
				// 	personalPhoneNumber: '',
				// 	personalEmail: '',
				// 	officePhoneNumber: '',
				// 	officeEmail: '',
				// 	currentAddress: {
				// 		city: '',
				// 		country: '',
				// 		district: '',
				// 		pinCode: '',
				// 		state: '',
				// 		street: '',
				// 	},
				// 	permanentAddress: {
				// 		city: '',
				// 		country: '',
				// 		district: '',
				// 		pinCode: '',
				// 		state: '',
				// 		street: '',
				// 	},
				// 	emergencyContact: {
				// 		name: '',
				// 		phoneNumber: '',
				// 	},
				// 	bankAccountDetails: {
				// 		IFSC: '',
				// 		accountHolderName: '',
				// 		accountNumber: '',
				// 		branch: '',
				// 		name: '',
				// 	},
				// });
			}
			this.setState({
				isAPISubmitting: false,
			});

			// return response;
		} else {
			this.setState({
				message: 'Something went wrong',
				isAPISubmitting: false,
			});
			// return response;
		}
	};

	getMemoryCardInfo = async (query, variables, receive = null, sendExistsOrNot = null) => {
		console.log(this.props);
		//Have to Update this
		this.checkUserLoggedIn();

		this.setState({ isMcFetching: true });
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		this.setState({ isEQFetching: false, qrCodeError: false });
		if (response[0] == true) {
			if (sendExistsOrNot === true) {
				return true;
			} else if (response[1].data.memoryCard !== null) {
				let equipment = response[1].data.memoryCard;
				if (receive == true) {
					equipment.isEmpty = false;
				}
				let employeeArray = equipment?.employees;

				this.setState({
					eqFetched: true,
					equipments: [equipment, ...this.state.equipments],
					qrCode: '',
					qrCodeErrorMessage:
						equipment.status != 'ready' && this.props.actionType === 'assign'
							? `Equipment is ${equipment.status}`
							: equipment.status != 'busy' && this.props.actionType !== 'assign'
							? `Equipment is ${equipment.status}`
							: (!employeeArray || employeeArray?.length == 0) &&
							  this.props.actionType !== 'assign'
							? 'No employees are assigned'
							: '',
					qrCodeError: this.props.actionType
						? (equipment.status != 'ready' && this.props.actionType === 'assign') ||
						  (equipment.status != 'busy' && this.props.actionType !== 'assign') ||
						  ((!employeeArray || employeeArray?.length == 0) &&
								this.props.actionType !== 'assign')
							? true
							: false
						: false,
				});
			} else {
				this.setState({
					eqFetched: true,
					qrCodeError: true,
					qrCodeErrorMessage: 'QR Code not found',
				});
			}
		} else {
			if (sendExistsOrNot === true) {
				return false;
			} else
				this.setState({
					qrCodeError: true,
					qrCodeErrorMessage: 'QR Code not found',
				});
		}
	};

	getEquipmentInfo = async (
		query,
		variables,
		receive = null,
		remap = null,
		sendExistsOrNot = null,
	) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		this.setState({ isEQFetching: true });
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			this.setState({ isEQFetching: false });

			if (sendExistsOrNot === true) {
				if (response[1].data.equpmentInfo !== null) return true;
				else return false;
			} else if (response[1].data.equpmentInfo !== null) {
				let equipment = response[1].data.equipmentInfo[0];
				if (remap == true) {
					this.setState({
						equipments: equipment,
						eqFetched: true,
						qrCodeErrorMessage: '',
						qrCodeError: false,
					});
				} else {
					let employeeArray = equipment?.employees;
					this.setState({
						equipments: [equipment, ...this.state.equipments],
						qrCode: '',
						qrCodeErrorMessage:
							equipment.status != 'ready' && this.state.actionType === 'assign'
								? `Equipment is ${equipment.status}`
								: equipment.status != 'busy' && this.state.actionType !== 'assign'
								? `Equipment is ${equipment.status}`
								: (!employeeArray || employeeArray?.length == 0) &&
								  this.state.actionType !== 'assign' &&
								  this.state.actionType !== 'receive'
								? 'No employees are assigned'
								: '',
						qrCodeError:
							(equipment.status != 'ready' && this.state.actionType === 'assign') ||
							(equipment.status != 'busy' && this.state.actionType !== 'assign') ||
							((!employeeArray || employeeArray?.length == 0) &&
								this.state.actionType !== 'assign')
								? true
								: false,
					});
				}
			} else {
				if (sendExistsOrNot === true) {
					if (response[1].data.equpmentInfo !== null) return true;
					else return false;
				} else {
					this.setState({
						qrCodeError: response[1].data.equipmentInfo == null ? true : false,
						qrCodeErrorMessage: 'Equipment Not Found',
					});
					if (remap == true) {
						this.setState({
							eqFetched: true,
						});
					}
				}
			}
		} else {
			this.setState({
				isEQFetching: false,
			});
			if (remap == true) {
				this.setState({
					eqFetched: true,
				});
			} else {
				this.setState({
					qrCodeError: true,
					qrCodeErrorMessage: 'Equipment Not Found',
				});
			}
		}
	};
	getAssetInfo = async (
		query,
		variables,
		receive = null,
		remap = null,
		sendExistsOrNot = null,
	) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		this.setState({ isEQFetching: true });
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			this.setState({ isAssetFetching: false });

			if (sendExistsOrNot === true) {
				if (response[1].data.asset !== null) return true;
				else return false;
			} else if (response[1].data.asset !== null) {
				let assetDetails = response[1].data.asset;
				if (remap == true) {
					this.setState({
						assetDetails: assetDetails,
						assetFetched: true,
						qrCodeErrorMessage: '',
						qrCodeError: false,
					});
				} else {
					this.setState({
						assetDetails: assetDetails,
						qrCode: '',
						qrCodeErrorMessage: '',
						qrCodeError: false,
					});
				}
			} else {
				if (sendExistsOrNot === true) {
					if (response[1].data.asset !== null) return true;
					else return false;
				} else {
					this.setState({
						qrCodeError: response[1].data.asset == null ? true : false,
						qrCodeErrorMessage: 'Equipment Not Found',
					});
					if (remap == true) {
						this.setState({
							assetFetched: true,
						});
					}
				}
			}
		} else {
			this.setState({
				isAssetFetching: false,
			});
			if (remap == true) {
				this.setState({
					assetFetched: true,
				});
			} else {
				this.setState({
					qrCodeError: true,
					qrCodeErrorMessage: 'Asset Not Found',
				});
			}
		}
	};
	getEmployeeAttendanceDetailsList = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		this.setState({ isEQFetching: true });
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			this.setState({
				isLoading: false,
				employeeAttendanceDetails: response[1].data.employeeAttendanceList,
			});
		}
	};
	getEquipmentSummary = async (query, variables, isFirstLoad = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let arr = [];
			let camera = _.find(response[1].data.equipmentSummary, {
				type: 'camera',
			});
			let lens = _.find(response[1].data.equipmentSummary, {
				type: 'lens',
			});

			if (camera && _.size(camera) > 0) {
				arr.push(camera);
			}

			if (lens && _.size(lens) > 0) {
				arr.push(lens);
			}

			_.forEach(response[1].data.equipmentSummary, (item, index) => {
				if (item.type !== 'camera' && item.type !== 'lens') {
					arr.push(item);
				}
			});

			let summaryData = [];

			_.forEach(arr, (item, index) => {
				let mainObj = {
					isExpanded: false,
					type: item.type,
					total: item.typeCount,
					readyCount: 0,
					assignedCount: 0,
					typeModels: {},
				};
				_.forEach(item.models, (model, inx) => {
					let modelKey = model.model !== null ? model.model : 'Unknown model';
					if (!_.has(mainObj.typeModels, modelKey)) {
						mainObj.typeModels[modelKey] = {
							busy: 0,
							ready: 0,
						};
					}

					if (model.status === 'ready') {
						mainObj.readyCount += model.count;
					} else if (model.status === 'busy') {
						mainObj.assignedCount += model.count;
					}

					mainObj.typeModels[modelKey][model.status] += model.count;
				});

				summaryData.push(mainObj);
			});

			if (isFirstLoad === true) {
				let typesFilters = [];

				typesFilters = _.map(summaryData, (eq) => {
					return {
						key: eq.type,
						name:
							eq.type.charAt(0).toUpperCase() +
							eq.type.replace(/([A-Z])/g, ' $1').slice(1),
					};
				});
				this.setState({
					typesFilters,
				});
			}
			this.setState({
				isLoading: false,
				equipmentSummary: summaryData,
			});
		} else {
		}
	};
	getTenantSettings = async (screenName = null) => {
		let usertoken = await localStorage.getItem('usertoken');

		let tenantInfo = await TenantsAction.getTenantSettings(
			this.props.match.params.workspaceID,
			usertoken,
		);

		if (tenantInfo[0]) {
			if (screenName === 'form-share') {
				let shareUrl = tenantInfo[1].logoUrl;
				this.setState({ shareUrl, tempShareUrl: shareUrl, isShareUrlLoading: false });
				return;
			}
			let facebookProfile, facebookProfileO;
			let instagramProfile, instagramProfileO;
			let pinterestProfile, pinterestProfileO;
			let linkedInProfile, linkedInProfileO;
			let address, addressO;
			let phoneNumber, phoneNumberO;
			let email, emailO;
			let website, websiteO;
			let businessName, businessNameO;

			facebookProfile = facebookProfileO = _.has(tenantInfo[1], 'facebookProfile')
				? 'www.facebook.com/' + tenantInfo[1].facebookProfile
				: 'www.facebook.com/';
			instagramProfile = instagramProfileO = _.has(tenantInfo[1], 'instagramProfile')
				? 'www.instagram.com/' + tenantInfo[1].instagramProfile
				: 'www.instagram.com/';
			pinterestProfile = pinterestProfileO = _.has(tenantInfo[1], 'pinterestProfile')
				? 'www.pinterest.com/' + tenantInfo[1].pinterestProfile
				: 'www.pinterest.com/';
			linkedInProfile = linkedInProfileO = _.has(tenantInfo[1], 'linkedInProfile')
				? 'www.linkedin.com/in/' + tenantInfo[1].linkedInProfile
				: 'www.linkedin.com/in/';
			address = addressO = _.has(tenantInfo[1], 'address') ? tenantInfo[1].address : '';
			phoneNumber = phoneNumberO = _.has(tenantInfo[1], 'phoneNumber')
				? tenantInfo[1].phoneNumber
				: '';
			email = emailO = _.has(tenantInfo[1], 'email') ? tenantInfo[1].email : '';
			websiteO = website = tenantInfo[1].website === null ? '' : tenantInfo[1].website;
			businessName = businessNameO = tenantInfo[1].businessName;
			this.setState({
				isLoading: false,
				businessName,
				businessNameO,
				tenantId: tenantInfo[1].workspaceId,
				website,
				websiteO,
				logoUrl: tenantInfo[1].logoUrl,
				facebookProfile,
				facebookProfileO,
				instagramProfile,
				instagramProfileO,
				pinterestProfile,
				pinterestProfileO,
				linkedInProfile,
				linkedInProfileO,
				address,
				addressO,
				phoneNumber,
				phoneNumberO,
				email,
				emailO,
			});

			if (screenName === 'customization') {
				let posactive =
					_.findIndex(this.state.positionMapping, (item) => {
						return tenantInfo[1].watermarkPosition === item;
					}) + 1;

				if (posactive === 1) {
					this.setState({
						tpos: 10,
						rpos: 'auto',
						bpos: 'auto',
						lpos: 10,
					});
				}
				if (posactive === 2) {
					this.setState({
						tpos: 10,
						rpos: 'calc(50% - 45px)',
						bpos: 'auto',
						lpos: 'auto',
					});
				}
				if (posactive === 3) {
					this.setState({
						tpos: 10,
						rpos: 10,
						bpos: 'auto',
						lpos: 'auto',
					});
				}
				if (posactive === 4) {
					this.setState({
						tpos: 'calc(50% - 20px)',
						rpos: 'auto',
						bpos: 'auto',
						lpos: 10,
					});
				}
				if (posactive === 5) {
					this.setState({
						tpos: 'calc(50% - 20px)',
						rpos: 'auto',
						bpos: 'auto',
						lpos: 'calc(50% - 45px)',
					});
				}
				if (posactive === 6) {
					this.setState({
						tpos: 'calc(50% - 20px)',
						rpos: 10,
						bpos: 'auto',
						lpos: 'auto',
					});
				}
				if (posactive === 7) {
					this.setState({
						tpos: 'auto',
						rpos: 'auto',
						bpos: 10,
						lpos: 10,
					});
				}
				if (posactive === 8) {
					this.setState({
						tpos: 'auto',
						rpos: 'auto',
						bpos: 10,
						lpos: 'calc(50% - 45px)',
					});
				}
				if (posactive === 9) {
					this.setState({
						tpos: 'auto',
						rpos: 10,
						bpos: 10,
						lpos: 'auto',
					});
				}
				this.setState({
					posactive,
				});
			}
		} else {
			if (_.has(tenantInfo[1], 'message')) {
				console.log('API Failed: ', tenantInfo[1].message);
			}
		}
	};
	uploadProfilePicture = async (file, employeeId) => {
		//let formData = new FormData();
		//console.log(file, file.name);

		//formData.append('displayPicture', file, file.name);

		let usertoken = await localStorage.getItem('usertoken');

		let response = await TenantsAction.uploadProfilePicture(
			employeeId, //have to employeeId here
			usertoken,
		);
		if (response[0] === true) {
			await this.axiosPutFileCallToS3BucketWithToast(file, response[1].signedUrl);
		} else {
			toast.promise(
				new Promise(async (resolve, reject) => {
					reject(true);
				}),
				{
					pending: 'Loading',
					success: '',
					error: 'Failed to Upload',
				},
				{
					theme: 'colored',
				},
			);
		}
	};

	axiosPutFileCallToS3BucketWithToast = async (file, uploadUrl) => {
		console.log(uploadUrl);
		console.log(file.type);
		let options = {
			headers: {
				'Content-Type': file.type,
			},
		};

		await toast.promise(
			new Promise(async (resolve, reject) => {
				let response = { status: null };
				try {
					response = await axios.put(uploadUrl, file, options);
				} catch (e) {
					console.log(e);
					reject(e);
				}
				if (response.status === 200) {
					resolve(true);
				} else {
					reject(true);
				}
			}),
			{
				pending: 'Loading',
				success: 'Profile Picture Uploaded',
				error: 'Failed to Upload',
			},
			{
				theme: 'colored',
			},
		);
	};
	getHardDrivesList = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			if (_.has(response[1].data, 'branchesList')) {
				let branchIdsFilters = [];
				branchIdsFilters = _.map(response[1].data.branchesList, (item) => {
					return {
						key: item.branchId,
						name: item.branchId,
					};
				});
				this.setState({
					branchIdsFilters,
				});
			}
			this.setState({
				hardDrivesList: response[1].data.vendorHardDriveList,
				isLoading: false,
				totalPages: response[1].data.vendorHardDriveList.totalPages,
				currentViewPage: response[1].data.vendorHardDriveList.currentPage,
				lengthOfList: response[1].data.vendorHardDriveList.totalDocs,
				isPageLoading: false,
			});
		}
	};
	getEmployeeList = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				employeeList: response[1].data.employees.data,
				isLoading: false,

				totalPages: response[1].data.employees.totalPages,
				currentViewPage: response[1].data.employees.currentPage,
				lengthOfList: response[1].data.employees.totalDocs,
				isPageLoading: false,
				isEmployeeLoading: false,
			});
		}
	};

	//There is another function by name getBranchList in tenantUsers.jsx
	//Pls don't change the name of this function
	getBranchList2 = async (query, type = null) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, {}, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			if (_.has(response[1].data, 'branchesList')) {
				if (type === null) {
					let branchesOptions = [];
					let barnchesFilters = [];
					let barnchesFilters2 = [];
					branchesOptions = _.map(response[1].data.branchesList, (item) => {
						return {
							value: item.id,
							label: item.branchId,
						};
					});
					barnchesFilters = _.map(response[1].data.branchesList, (item) => {
						return {
							key: item.id,
							name: item.branchId,
						};
					});
					barnchesFilters2 = _.map(response[1].data.branchesList, (item) => {
						return {
							key: item.branchId,
							name: item.branchId,
						};
					});
					this.setState({
						branchesOptions,
						barnchesFilters2,
						barnchesFilters,
						isBranchesListLoading: false,
					});
				} else if (type === 'branchList') {
					let branchesListOption = [];
					branchesListOption = _.map(response[1].data.branchesList, (item) => {
						return {
							value: item.branchId,
							label: item.branchId,
						};
					});
					this.setState({
						branchesListOption,
					});
				} else if (type === 'branchIdsFilters') {
					let branchIdsFilters = [];
					branchIdsFilters = _.map(response[1].data.branchesList, (item) => {
						return {
							key: item.branchId,
							name: item.branchId,
						};
					});
					this.setState({
						branchIdsFilters,

						isBranchIdsFiltersLoading: false,
					});
				}
			}

			// this.setState({

			// });
		}
	};
	getEmployeeAttendanceFilters = async (query, type = null) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, {}, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let departmentOptions = [];
			let officeOptions = [];

			departmentOptions = _.map(response[1].data.attendancefilters.department, (item) => {
				return {
					key: item,
					name: item,
				};
			});
			officeOptions = _.map(response[1].data.attendancefilters.divisionId, (item) => {
				return {
					key: item,
					name: item,
				};
			});

			this.setState({
				departmentOptions,
				officeOptions,
			});

			// this.setState({

			// });
		}
	};
	getWorkSpaceOptions = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			// if (_.has(response[1].data, 'branchesList')) {
			let workspaceOptions = [];
			workspaceOptions = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
				return {
					value: item.workspaceId,
					label: item.workspaceId,
				};
			});
			this.setState({
				workspaceOptions,
			});
			// }

			// this.setState({

			// });
		}
	};
	getEmployeeDefaultfilters = async (query) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, {}, vendorID, usertoken, 'vendors');
		// console.log('result', response);

		if (response[0] == true) {
			console.log(response[1].data.employeeDefaultfilters.department);
			// if (_.has(response[1].data, 'branchesList')) {
			let departments = [];
			let departmentsFilters = [];

			for (let i = 0; i < response[1].data.employeeDefaultfilters.department.length; i++) {
				departments.push({
					value: response[1].data.employeeDefaultfilters.department[i],
					label: response[1].data.employeeDefaultfilters.department[i],
				});
			}
			departments = _.map(response[1].data.employeeDefaultfilters.department, (item) => {
				return {
					value: item,
					label: item,
				};
			});

			departmentsFilters = _.map(
				response[1].data.employeeDefaultfilters.department,
				(item) => {
					return {
						key: item,
						name: item,
					};
				},
			);
			let assignedToFilters = [];
			assignedToFilters = _.map(response[1].data.employeeDefaultfilters.employees, (item) => {
				return {
					key: item._id,
					name: item.displayName ? item.displayName : item.fullName,
				};
			});
			let assignedToOptions = [];
			assignedToOptions = _.map(response[1].data.employeeDefaultfilters.employees, (item) => {
				return {
					value: item._id,
					label: item.fullName,
				};
			});

			let designations = [];
			designations = _.map(response[1].data.employeeDefaultfilters.designation, (item) => {
				let label = item
					.replace(/([a-z])([A-Z])/g, '$1 $2')
					.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
				return {
					value: item,
					label: label,
				};
			});
			let brandFilters = [];
			brandFilters = _.map(response[1].data.employeeDefaultfilters.workspaceId, (item) => {
				let label = item
					.replace(/([a-z])([A-Z])/g, '$1 $2')
					.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
				return {
					key: item,
					name: label,
				};
			});
			this.setState({
				departments,
				mydata: response[1].data.employeeDefaultfilters.department,
				designations,
				departmentsFilters,
				brandFilters,
				assignedToFilters,
				assignedToOptions,
			});
			// }

			this.setState({});
		}
	};

	getEmployeeDetails = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				employeeDetails: response[1].data.getEmployee,
				imageSrc: response[1].data.getEmployee.dp_signed_url,
				/* ? `https://display.cragy.in/${response[1].data.getEmployee.dp_b2_300w_key}`
					: null, */
			});
		}
	};
	// getEmployeeDefaultfilters = async (query, variables) => {
	// 	let usertoken = localStorage.getItem('usertoken');
	// 	let vendorID = this.props.params.vendorID;
	// 	let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
	// 	console.log(response);
	// 	if (response[0] == true) {
	// 		this.setState({
	// 			gotdefautFilters: true,
	// 			mydata: response[1].data.employeeDefaultfilters,
	// 		});
	// 	}
	// };
	checkEmployee = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			if (response[1].data.checkIfEmployee === null) {
				this.setState({
					// employeeDetails: response[1].data.getEmployee,
					employeeExistsCheck: false,
					existmessage: '',
				});
			} else {
				this.setState({
					employeeExistsCheck: true,
					existmessage: 'User with this email or phone no. already exists',
				});
			}
		}
	};
	getEmployeeDetails2 = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				isemployeeloading: false,
				isemployeedetails2loading: false,
				employeeDetails: response[1].data.getEmployee,
				// firstName: response[1].data.getEmployee.firstName,
				// lastName: response[1].data.getEmployee.lastName,
				fullName: response[1].data.getEmployee.fullName,
				prevFullName: response[1].data.getEmployee.fullName,
				displayName: response[1].data.getEmployee.displayName,
				prevDisplayName: response[1].data.getEmployee.displayName,
				employeeId: response[1].data.getEmployee.id,
				prevEmployeeId: response[1].data.getEmployee.id,
				employeeId2: response[1].data.getEmployee.employeeId,
				prevEmployeeId2: response[1].data.getEmployee.employeeId,
				gender: response[1].data.getEmployee.gender,
				prevGender: response[1].data.getEmployee.gender,

				imageSrc: response[1].data.getEmployee.dp_signed_url,
				/* ? `https://display.cragy.in/${response[1].data.getEmployee.dp_b2_300w_key}`
					: null, */
				genderType: response[1].data.getEmployee.gender
					? {
							value: response[1].data.getEmployee.gender,
							label:
								response[1].data.getEmployee.gender[0] +
								response[1].data.getEmployee.gender.slice(1).toLowerCase(),
					  }
					: {},
				prevGenderType: response[1].data.getEmployee.gender
					? {
							value: response[1].data.getEmployee.gender,
							label:
								response[1].data.getEmployee.gender[0] +
								response[1].data.getEmployee.gender.slice(1).toLowerCase(),
					  }
					: {},
				selectedDob: response[1].data.getEmployee.dob
					? moment(response[1].data.getEmployee.dob.toString(), 'YYYYMMDD').format(
							'YYYY-MM-DD',
					  )
					: '',
				prevSelectedDob: response[1].data.getEmployee.dob
					? moment(response[1].data.getEmployee.dob.toString(), 'YYYYMMDD').format(
							'YYYY-MM-DD',
					  )
					: '',
				dob: response[1].data.getEmployee.dob,
				prevDob: response[1].data.getEmployee.dob,
				selectedDepartment: response[1].data.getEmployee.department
					? {
							label: response[1].data.getEmployee.department,
							value: response[1].data.getEmployee.department,
					  }
					: '',
				prevSelectedDepartment: response[1].data.getEmployee.department
					? {
							label: response[1].data.getEmployee.department,
							value: response[1].data.getEmployee.department,
					  }
					: '',
				selectedDesignation: response[1].data.getEmployee.designation
					? {
							label: response[1].data.getEmployee.designation
								.replace(/([a-z])([A-Z])/g, '$1 $2')
								.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase()),
							value: response[1].data.getEmployee.designation,
					  }
					: '',
				prevSelectedDesignation: response[1].data.getEmployee.designation
					? {
							label: response[1].data.getEmployee.designation
								.replace(/([a-z])([A-Z])/g, '$1 $2')
								.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase()),
							value: response[1].data.getEmployee.designation,
					  }
					: '',
				selectedBloodGroup: response[1].data.getEmployee.bloodGroup
					? {
							label: response[1].data.getEmployee.bloodGroup,
							value: response[1].data.getEmployee.bloodGroup,
					  }
					: '',
				prevSelectedBloodGroup: response[1].data.getEmployee.bloodGroup
					? {
							label: response[1].data.getEmployee.bloodGroup,
							value: response[1].data.getEmployee.bloodGroup,
					  }
					: '',
				bloodGroup: response[1].data.getEmployee.bloodGroup
					? response[1].data.getEmployee.bloodGroup
					: null,
				prevBloodGroup: response[1].data.getEmployee.bloodGroup
					? response[1].data.getEmployee.bloodGroup
					: null,
				aadharNumber: response[1].data.getEmployee.aadharNumber,
				assets: response[1].data.getEmployee.assets,
				prevAadharNumber: response[1].data.getEmployee.aadharNumber,
				panNumber: response[1].data.getEmployee.panNumber,
				prevPanNumber: response[1].data.getEmployee.panNumber,
				selectedJoiningDate: response[1].data.getEmployee.joiningDate
					? moment(
							response[1].data.getEmployee.joiningDate.toString(),
							'YYYYMMDD',
					  ).format('YYYY-MM-DD')
					: '',
				prevSelectedJoiningDate: response[1].data.getEmployee.joiningDate
					? moment(
							response[1].data.getEmployee.joiningDate.toString(),
							'YYYYMMDD',
					  ).format('YYYY-MM-DD')
					: '',
				joiningDate: response[1].data.getEmployee.joiningDate,
				prevJoiningDate: response[1].data.getEmployee.joiningDate,

				employeeTypeSelect: response[1].data.getEmployee.employeeType
					? {
							value: response[1].data.getEmployee.employeeType,
							label:
								response[1].data.getEmployee.employeeType[0] +
								response[1].data.getEmployee.employeeType.slice(1).toLowerCase(),
					  }
					: {},
				prevEmployeeTypeSelect: response[1].data.getEmployee.employeeType
					? {
							value: response[1].data.getEmployee.employeeType,
							label:
								response[1].data.getEmployee.employeeType[0] +
								response[1].data.getEmployee.employeeType.slice(1).toLowerCase(),
					  }
					: {},
				employeeType: response[1].data.getEmployee.employeeType
					? response[1].data.getEmployee.employeeType
					: null,
				prevEmployeeType: response[1].data.getEmployee.employeeType
					? response[1].data.getEmployee.employeeType
					: null,
				selectedBrand: response[1].data.getEmployee.workspaceId
					? {
							value: response[1].data.getEmployee.workspaceId,
							label: response[1].data.getEmployee.workspaceId,
					  }
					: {},
				prevSelectedBrand: response[1].data.getEmployee.workspaceId
					? {
							value: response[1].data.getEmployee.workspaceId,
							label: response[1].data.getEmployee.workspaceId,
					  }
					: {},
				brandString: response[1].data.getEmployee.workspaceId,
				prevBrandString: response[1].data.getEmployee.workspaceId,
				prevSelectedBrandString: response[1].data.getEmployee.workspaceId,
				selectedBrandString: response[1].data.getEmployee.workspaceId,

				department: response[1].data.getEmployee.department,

				designation: response[1].data.getEmployee.designation,
				prevDesignation: response[1].data.getEmployee.designation,
				monthlySalaryPreTax: response[1].data.getEmployee.monthlySalaryPreTax,
				prevMonthlySalaryPreTax: response[1].data.getEmployee.monthlySalaryPreTax,
				selectedBranch: response[1].data.getEmployee.branch
					? {
							value: response[1].data.getEmployee.branch._id,
							label: response[1].data.getEmployee.branch.branchId,
					  }
					: {},
				prevSelectedBranch: response[1].data.getEmployee.branch
					? {
							value: response[1].data.getEmployee.branch._id,
							label: response[1].data.getEmployee.branch.branchId,
					  }
					: {},
				branchIdString: response[1].data.getEmployee.branch
					? response[1].data.getEmployee.branch.branchId
					: '',
				prevBranchIdString: response[1].data.getEmployee.branch
					? response[1].data.getEmployee.branch.branchId
					: '',
				branchId: response[1].data.getEmployee.branch
					? response[1].data.getEmployee.branch._id
					: '',
				prevBranchId: response[1].data.getEmployee.branch
					? response[1].data.getEmployee.branch._id
					: '',
				selectedStatus: response[1].data.getEmployee.status
					? {
							value: response[1].data.getEmployee.status,
							label:
								response[1].data.getEmployee.status[0] +
								response[1].data.getEmployee.status.slice(1).toLowerCase(),
					  }
					: {},
				prevSelectedStatus: response[1].data.getEmployee.status
					? {
							value: response[1].data.getEmployee.status,
							label:
								response[1].data.getEmployee.status[0] +
								response[1].data.getEmployee.status.slice(1).toLowerCase(),
					  }
					: {},
				statusString: response[1].data.getEmployee.status
					? response[1].data.getEmployee.status
					: null,
				prevStatusString: response[1].data.getEmployee.status
					? response[1].data.getEmployee.status
					: null,
				personalPhoneNumber: response[1].data.getEmployee.personalPhoneNumber.slice(3),
				prevPersonalPhoneNumber: response[1].data.getEmployee.personalPhoneNumber.slice(3),
				personalEmail: response[1].data.getEmployee.personalEmail,
				prevPersonalEmail: response[1].data.getEmployee.personalEmail,
				officePhoneNumber: response[1].data.getEmployee.officePhoneNumber
					? response[1].data.getEmployee.officePhoneNumber.slice(3)
					: null,
				prevOfficePhoneNumber: response[1].data.getEmployee.officePhoneNumber
					? response[1].data.getEmployee.officePhoneNumber.slice(3)
					: null,
				officeEmail: response[1].data.getEmployee.officeEmail
					? response[1].data.getEmployee.officeEmail
					: null,
				prevOfficeEmail: response[1].data.getEmployee.officeEmail
					? response[1].data.getEmployee.officeEmail
					: null,
				currentAddress: {
					city: response[1].data.getEmployee.currentAddress.city,
					country: response[1].data.getEmployee.currentAddress.country,
					district: response[1].data.getEmployee.currentAddress.district,
					pinCode: response[1].data.getEmployee.currentAddress.pinCode,
					state: response[1].data.getEmployee.currentAddress.state,
					street: response[1].data.getEmployee.currentAddress.street,
				},
				prevCurrentAddress: {
					city: response[1].data.getEmployee.currentAddress.city,
					country: response[1].data.getEmployee.currentAddress.country,
					district: response[1].data.getEmployee.currentAddress.district,
					pinCode: response[1].data.getEmployee.currentAddress.pinCode,
					state: response[1].data.getEmployee.currentAddress.state,
					street: response[1].data.getEmployee.currentAddress.street,
				},
				permanentAddress: {
					city: response[1].data.getEmployee.permanentAddress.city,
					country: response[1].data.getEmployee.permanentAddress.country,
					district: response[1].data.getEmployee.permanentAddress.district,
					pinCode: response[1].data.getEmployee.permanentAddress.pinCode,
					state: response[1].data.getEmployee.permanentAddress.state,
					street: response[1].data.getEmployee.permanentAddress.street,
				},
				prevPermanentAddress: {
					city: response[1].data.getEmployee.permanentAddress.city,
					country: response[1].data.getEmployee.permanentAddress.country,
					district: response[1].data.getEmployee.permanentAddress.district,
					pinCode: response[1].data.getEmployee.permanentAddress.pinCode,
					state: response[1].data.getEmployee.permanentAddress.state,
					street: response[1].data.getEmployee.permanentAddress.street,
				},
				emergencyContact: {
					name: response[1].data.getEmployee.emergencyContact.name,
					phoneNumber: response[1].data.getEmployee.emergencyContact.phoneNumber.slice(3),
					relation: response[1].data.getEmployee.emergencyContact.relation,
				},
				prevEmergencyContact: {
					name: response[1].data.getEmployee.emergencyContact.name,
					phoneNumber: response[1].data.getEmployee.emergencyContact.phoneNumber.slice(3),
					relation: response[1].data.getEmployee.emergencyContact.relation,
				},
				bankAccountDetails: {
					IFSC: response[1].data.getEmployee.bankAccountDetails.IFSC,
					accountHolderName:
						response[1].data.getEmployee.bankAccountDetails.accountHolderName,
					accountNumber: response[1].data.getEmployee.bankAccountDetails.accountNumber,
					branch: response[1].data.getEmployee.bankAccountDetails.branch,
					bankName: response[1].data.getEmployee.bankAccountDetails.bankName,
				},
				prevBankAccountDetails: {
					IFSC: response[1].data.getEmployee.bankAccountDetails.IFSC,
					accountHolderName:
						response[1].data.getEmployee.bankAccountDetails.accountHolderName,
					accountNumber: response[1].data.getEmployee.bankAccountDetails.accountNumber,
					branch: response[1].data.getEmployee.bankAccountDetails.branch,
					bankName: response[1].data.getEmployee.bankAccountDetails.bankName,
				},
			});
		}
	};
	getShootInfo = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			// let clientsArr =
			// 	_.size(response[1].data.project.clients) > 0
			// 		? _.filter(response[1].data.project.clients, function (o) {
			// 				return o.type === 'groom' || o.type === 'bride';
			// 		  })
			// 		: null;

			// let bride =
			// 	clientsArr !== null
			// 		? _.filter(clientsArr, function (o) {
			// 				return o.type === 'bride';
			// 		  })[0].name
			// 		: null;
			// let groom =
			// 	clientsArr !== null
			// 		? _.filter(clientsArr, function (o) {
			// 				return o.type === 'groom';
			// 		  })[0].name
			// 		: null;

			let mcLogsList = [];
			let mcFilterList = { All: [] };

			mcLogsList = response[1].data.vendorEvent.memoryCards
				? response[1].data.vendorEvent.memoryCards
				: [];

			_.forEach(mcLogsList, (item, index) => {
				let totalBackUpSize = 0;
				_.forEach(item.backupLogs, (itm, i) => {
					if (itm.backupSize && itm.backupSize > 0) {
						totalBackUpSize += itm.backupSize;
					}
				});
				item.totalBackUpSize = totalBackUpSize;
				mcFilterList.All.push(item);
				/* if (!_.has(mcFilterList, item.userName)) {
					mcFilterList[item.userName] = [];
				}
				mcFilterList[item.userName].push(item); */
			});

			response[1].data.vendorEvent.memoryCards = mcFilterList.All;

			this.setState({
				isLoading: false,

				eventDetails: response[1].data.vendorEvent,
				isEquipmentReceived:
					_.has(response[1].data.vendorEvent, 'equipments') &&
					_.size(
						_.filter(response[1].data.vendorEvent['equipments'], {
							isReceived: true,
						}),
					) > 0
						? true
						: false,
				//bride,
				//groom,
				//crewDetails,
			});
		}
	};

	getProjects = async (query, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			if (type === 'value-label') {
				let projectNameOptions = [...this.state.projectNameOptions];
				let projectId = this.state.projectId;
				let listDetails = {};
				listDetails = response[1].data.vendorsProjects.data;

				projectNameOptions = _.map(listDetails.data, (item) => {
					return {
						value: item.id,
						label: item.title,
					};
				});

				if (_.size(projectNameOptions) > 0) {
					if (projectId === null) {
						projectId = projectNameOptions[0].value;
					}
				}

				this.setState({
					projectNameOptions: projectNameOptions,
					projectsNameList: listDetails,
					isProjectsLoading: false,
					projectId,
					hasNextPage: false,
					isProjectsPageLoading: false,
				});
				return listDetails;
			}

			return _.map(response[1].data.vendorsProjects.data, (item) => {
				return {
					key: item.id,
					name: item.title,
				};
			});
		} else {
			return false;
		}
	};

	getVendorsWorkspaces = async (query, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let workspacesFilters = [];
			workspacesFilters = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
				return {
					key: item._id,
					name: item.workspaceId,
					label: item.workspaceId,
					value: item.workspaceId,
					workspaceKey: item.workspaceKey,
				};
			});
			let workspaceList = [];

			workspaceList = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
				return {
					key: item._id,
					// name: item.workspaceId,
					// label: item.workspaceId,
					workspaceId: item.workspaceId,
					workspaceKey: item.workspaceKey,
				};
			});
			let workspaceOptions = [];
			workspaceOptions = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
				return {
					label: item.workspaceId,
					value: item._id,
				};
			});

			this.setState({
				workspacesFilters,
				vendorInfo: response[1].data.vendorInfo,
				workspaceList,
				workspaceOptions,
			});

			if (type === 'modify-object') {
				let workspacesFilters = [];
				workspacesFilters = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
					return {
						key: item.workspaceId,
						name: item.workspaceId,
						workspaceKey: item.workspaceKey,
						workspaceid: item._id,
					};
				});

				this.setState({
					workspacesFilters,
				});
			}

			this.setState({
				isWorkspaceFiltersLoading: false,
			});
			return workspacesFilters;
		} else {
			return false;
		}
	};
	getProjectsOptions = async (query, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let projectsOptions = [];
			projectsOptions = _.map(response[1].data.vendorsProjects.data, (item) => {
				return {
					label: item.title,
					value: item.id,
				};
			});

			this.setState({
				projectsOptions,
			});
		} else {
			return false;
		}
	};
	getDeliverableOptions = async (query, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let deliverableOptions = [];
			deliverableOptions = _.map(response[1].data.vendorDeliverablesList.data, (item) => {
				return {
					label: item.title,
					value: item.id,
				};
			});

			this.setState({
				deliverableOptions,
			});
		} else {
			return false;
		}
	};

	getTenantUsersListForMc = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let tenantUsersList = [];
			let tenantUsersListOptions = [{ value: null, label: 'Select User' }];

			tenantUsersList = _.filter(response[1].data.vendorTenantUsersList.data, {
				isEmailVerified: true,
			});

			_.forEach(tenantUsersList, (user, key) => {
				tenantUsersListOptions.push({
					label: user.firstName + ' ' + user.lastName,
					value: user.id,
				});
			});
			this.setState({
				tenantUsersList,
				tenantUsersListOptions,
				isTenantUsersLoading: false,
			});
			return tenantUsersList;
		} else {
			return false;
		}
	};

	getMemoryCard = async (query, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		this.setState({ isMcFetching: true });
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			if (_.has(response[1], 'errors')) {
				this.setState({
					qrCodeError: true,
					qrCodeErrorMessage: response[1].errors[0].message,
				});
			} else {
				let mcDetails = {};
				let mcList = this.state.mcList;
				if (type === null) {
					mcList.push(response[1].data.memoryCard);
				} else if (type === 'addIsEmpty') {
					let mcTempList = {
						...response[1].data.memoryCard,
						isEmpty: false,
					};
					mcList.push(mcTempList);
				}
				this.setState({
					qrCodeInputValue: '',
					mcList,
					mcDetails: response[1].data.memoryCard,
				});
			}
		} else {
			this.setState({
				qrCodeError: true,
				qrCodeErrorMessage: 'Error try again!',
			});
		}
		this.setState({ isMcFetching: false });
	};

	getProjectNameList = async (query, variables, type = null, actionType = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID =
			actionType === null ? this.props.params.vendorID : this.props.params.workspaceID;
		var response = await service.query(
			query,
			variables,
			vendorID,
			usertoken,
			actionType === null ? 'vendors' : null,
		);

		if (response[0] == true) {
			let projectNameOptions = [...this.state.projectNameOptions];
			let eventNameOptions = [{ value: null, label: 'Select' }];
			let projectId = this.state.projectId;
			let listDetails = {};

			if (type === 'expense') {
				listDetails = response[1].data.vendorEventsList;
			} else {
				listDetails = {
					hasNextPage: false,
					data:
						actionType === null
							? response[1].data.vendorsProjects
							: response[1].data.projects,
				};
			}
			if (type === 'expense') {
				let tempListDetails = [];
				_.forEach(listDetails.data, (item, index) => {
					tempListDetails.push(item);
					_.forEach(item.childEvents, (itm, inx) => {
						let found = undefined;
						found = _.find(tempListDetails, { id: '_id' });
						if (found) {
						} else {
							itm.id = itm._id;
							itm.crewNew = item?.crewNew;
							tempListDetails.push(itm);
						}
					});
				});

				listDetails.data = tempListDetails;
				eventNameOptions = [
					...eventNameOptions,
					..._.map(listDetails.data, (item) => {
						return {
							value: item.id,
							label: type === null ? item.title : item.name,
						};
					}),
				];
			} else {
				projectNameOptions = [
					...projectNameOptions,
					..._.map(listDetails.data, (item) => {
						return {
							value: item.id,
							label: type === null ? item.title : item.name,
						};
					}),
				];

				if (_.size(projectNameOptions) > 0 && variables.filters.page === 1) {
					if (type === null && projectId === null) {
						projectId = projectNameOptions[0].value;
					}
				}

				this.setState({
					projectNameOptions: projectNameOptions,
					projectsNameList: [...this.state.projectsNameList, ...listDetails.data],
					isProjectsLoading: false,
					projectId,
					hasNextPage: listDetails.hasNextPage,
					isProjectsPageLoading: false,
				});
				return listDetails.data;
			}
			if (
				_.size(eventNameOptions) > 0 &&
				variables.filters.page === 1 &&
				type === 'expense'
			) {
				let eventId = null;
				if (_.has(this.props, 'activeExpenseID') && this.props.activeExpenseID !== null) {
					let found = undefined;
					found = _.find(eventNameOptions, (event, index) => {
						return event.value === this.state.expenseDetails.eventId;
					});
					if (found) {
						eventId = found.value;
					}
				}
				this.setState({
					eventId,
					eventNameOptions: eventNameOptions,
					eventsNameList: [...this.state.eventsNameList, ...listDetails.data],
					isEventsLoading: false,
					projectId,
					hasNextEventsPage: listDetails.hasNextPage,
					isEventsPageLoading: false,
				});
				return listDetails.data;
			}
		} else {
			return false;
		}
	};

	addNewProjectNote = async (mutation, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.mutation(mutation, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let notes =
				type === 'shoot'
					? [...response[1].data.addEventNote.notes]
					: type === 'expense'
					? [...response[1].data.addExpenseNote.notes]
					: type === 'payment'
					? [...response[1].data.addClientPaymentNote.notes]
					: type === 'deliverable'
					? [...response[1].data.addDeliverableNote.notes]
					: [...response[1].data.addProjectNote.notes];
			notes = _.map(notes, (note, indx) => {
				delete note['__typename'];
				return note;
			});
			return notes;
		} else {
			return false;
		}
	};

	deleteProjectNote = async (mutation, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.mutation(mutation, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			return response[1].data;
		} else {
			return false;
		}
	};

	putExpense = async (
		mutation,
		variables,
		getExpenseMutation,
		type = 'update',
		actionType = null,
	) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let workspaceID =
			actionType === null ? this.props.params.workspaceID : this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					mutation,
					variables,
					workspaceID,
					usertoken,
					actionType === null ? null : 'vendors',
				);
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Expense ${
					type === 'add' ? 'added' : type === 'update' ? 'updated' : 'deleted'
				}!`,
				error: `Failed to ${type} Expense!`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (_.has(this.props, 'expenseDetailsUpdated')) {
				this.props.expenseDetailsUpdated();
			}
			if (_.has(this.props, 'close')) {
				this.props.close();
			}
		} else {
			return false;
		}
	};

	getExpense = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			if (
				_.has(response[1].data.vendorExpense, 'eventId') &&
				response[1].data.vendorExpense.eventId
			) {
				let json = {
					projectId: response[1].data.vendorExpense.projectId,
					vendorEventId: response[1].data.vendorExpense.eventId,
					workspaceId: _.has(this.props, 'workspaceID')
						? this.props.workspaceID
						: this.props.params.workspaceID,
				};

				const getEvent = gql`
					query VendorEvent($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
						vendorEvent(
							projectId: $projectId
							id: $vendorEventId
							workspaceId: $workspaceId
						) {
							crew {
								count
								role
								managerIds
								subRole
								userIds
							}
							crewNew {
								userId
								roles {
									role
									subRole
								}
								isManager
								isCustomUser
							}
							id
						}
					}
				`;
				let res = await this.getSingleEvent(getEvent, json);
				if (res !== false) {
					let spentByOptions = [{ value: null, label: 'Select' }];

					if (_.size(res.crewNew) > 0) {
						_.forEach(res.crewNew, (user) => {
							let found = _.find(this.props.tenantUsersList, { id: user.userId });
							if (found !== undefined) {
								spentByOptions.push({
									value: found.id,
									label:
										found.firstName +
										(found.lastName ? ` ${found.lastName}` : ''),
								});
							}
						});
					}

					this.setState({
						spentByOptions,
					});
				}
			}
			return response[1].data.vendorExpense;
		} else {
			console.log(response);
			return false;
		}
	};

	assignMemoryCard = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		/* await toast.promise(
			new Promise(async (resolve, reject) => {
				
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Memory Card Assigned!`,
				error: `Failed to assign Memory Card`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		); */
		if (response[0] == true) {
			if (_.has(response[1], 'errors')) {
				this.setState({
					isAssignError: true,
					isAssignErrorMessage: response[1].errors[0].message,
				});
				return false;
			} else {
				this.setState({
					currStep: '4',
					isAssignError: false,
					isAssignErrorMessage: '',
				});
				if (_.has(this.props, 'mcDetailsUpdated')) {
					this.props.mcDetailsUpdated();
				}
				return true;
			}
		} else {
			this.setState({
				isAssignError: true,
				isAssignErrorMessage: 'Failed to assign Memory Card. Try again.',
			});
			return false;
		}
		this.setState({ isAssignLoading: false });
	};

	receiveMemoryCard = async (query, variables, isFullPage = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		/* await toast.promise(
			new Promise(async (resolve, reject) => { */
		response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		/* 		if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Memory Card received!`,
				error: `Failed to receive Memory Card`,
			},
			{
				theme: 'colored',
				autoClose: 2000,
			},
		); */
		if (response[0] == true) {
			if (_.has(response[1], 'errors')) {
				this.setState({
					isReceiveError: true,
					isReceiveErrorMessage: response[1].errors[0].message,
				});
				return false;
			} else {
				this.setState({
					isReceiveError: false,
					isReceiveErrorMessage: '',
				});
				if (isFullPage == true) {
					return response;
				} else {
					if (_.has(this.props, 'mcDetailsUpdated')) {
						this.props.mcDetailsUpdated();
					}
					this.props.handleClose();
				}
			}
		} else {
			this.setState({
				isReceiveError: true,
				isReceiveErrorMessage: 'Failed to receive Memory Card. Try again.',
			});
			return false;
		}
	};

	getEventMemoryCardLogs = async (query, variables, isWithoutLoading = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		if (isWithoutLoading === null) {
			this.setState({ isMcLogsFetching: true });
		}
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			if (_.has(response[1], 'errors')) {
				this.setState({
					mcLogsSummaryError: true,
					mcLogsSummaryErrorMessage: response[1].errors[0].message,
				});
			} else {
				let mcLogsList = [];
				let mcFilterList = { All: [] };

				mcLogsList = response[1].data.vendorEvent.memoryCards
					? response[1].data.vendorEvent.memoryCards
					: [];

				if (isWithoutLoading !== null && this.state.selectedMC.qrCode) {
					let found = _.find(mcLogsList, {
						qrCode: this.state.selectedMC.qrCode,
					});
					if (found) {
						this.setState({ selectedMC: found });
					}
				}

				_.forEach(mcLogsList, (item, index) => {
					let totalBackUpSize = 0;
					_.forEach(item.backupLogs, (itm, i) => {
						if (itm.backupSize && itm.backupSize > 0) {
							totalBackUpSize += itm.backupSize;
						}
					});
					item.totalBackUpSize = totalBackUpSize;
					mcFilterList.All.push(item);
					if (!_.has(mcFilterList, item.userName)) {
						mcFilterList[item.userName] = [];
					}
					mcFilterList[item.userName].push(item);
				});

				let eventDetails = _.cloneDeep(this.state.eventDetails);
				eventDetails.memoryCards = mcFilterList.All;
				let selectedMC = _.filter(mcLogsList, {
					qrCode: this.state.selectedMC.qrCode,
				})[0];

				this.setState(
					{
						eventDetails,
						mcLogsList,
						tempMcLogsList: mcFilterList.All,
						/* mcFilterList,
						tempMcFilterList: _.cloneDeep(mcFilterList), */
						mcLogsSummaryError: false,
						mcLogsSummaryErrorMessage: '',
						selectedMC,
					},
					() => {
						if (isWithoutLoading === null) {
							if (_.has(this, 'showRecordMCModal')) {
								this.setState({
									showRecordMCModal: false,
								});
							}
						}
						if (_.size(this.state.mcSearchQuery) > 0 && _.has(this, 'onMcSearch')) {
							this.onMcSearch(this.state.mcSearchQuery);
						}
					},
				);
			}
		} else {
			this.setState({
				mcLogsSummaryError: true,
				mcLogsSummaryErrorMessage: 'Error try again!',
			});
		}
		this.setState({ isMcLogsFetching: false });
	};

	updateMCStatus = async (query, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `${
					type === 'Released'
						? 'Memory Card Released'
						: `Memory Card ${type === null ? 'backup' : type} submitted!`
				}`,
				error: `${
					type === 'Released'
						? 'Failed to Rlease Memory Card'
						: `Failed to submit for Memory Card ${type === null ? 'backup' : type}`
				}`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (_.has(this.props, 'mcDetailsUpdated')) {
				this.props.mcDetailsUpdated();
			}
			if (_.has(this.props, 'close')) {
				this.props.close();
			}
		} else {
		}
	};

	updateMemoryCard = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Memory Card Updated`,
				error: `Failed to submit for Memory Card `,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (_.has(this.props, 'mcDetailsUpdated')) {
				this.props.mcDetailsUpdated();
			}
		} else {
		}
	};

	updateDeleteAddProjectCollaborator = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;

		var response = [];
		response[0] = false;
		try {
			response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		} catch (e) {
			return false;
		}

		if (response[0] == true) {
			return true;
		} else {
			return false;
		}
	};

	getFileSignedUrl = async (query, variables, type = null, actionType = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = type === null ? this.props.params.vendorID : this.props.params.workspaceID;
		var response = await service.query(
			query,
			variables,
			vendorID,
			usertoken,
			type === null ? 'vendors' : null,
		);
		if (response[0] == true) {
			if (type === null) {
				if (actionType === 'vendors') {
					return response[1].data.getVendorFileSignedUrl;
				} else {
					return response[1].data.getProjectFileSignedUrl;
				}
			} else if (type === 'workspace') {
				return response[1].data.getTenantFileSignedUrl;
			}
		} else {
			return false;
		}
	};

	attachFile = async (mutation, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		try {
			response = await service.mutation(mutation, variables, vendorID, usertoken, 'vendors');
		} catch (e) {
			console.log(e);
			return false;
		}
		if (response[0] == true) {
			return true;
		} else {
			return false;
		}
	};

	getHardDriveNameList = async (query, variables, removeDuplicate = null) => {
		//Have to Update thisgetSearchedProjectsList
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			let hardDriveNameOptions = [];

			// if (
			// 	removeDuplicate === true &&
			// 	_.has(this.props, 'selectedMC') &&
			// 	_.has(this.props.selectedMC, 'backupLogs') &&
			// 	_.size(this.props.selectedMC.backupLogs) > 0
			// ) {
			// 	response[1].data.vendorHardDriveList.data = _.filter(
			// 		response[1].data.vendorHardDriveList.data,
			// 		(item, index) => {
			// 			let found = _.find(this.props.selectedMC.backupLogs, {
			// 				hddQrCode: item.qrCode,
			// 			});
			// 			if (found) {
			// 				return false;
			// 			} else {
			// 				return true;
			// 			}
			// 		},
			// 	);
			// }

			_.forEach(response[1].data.vendorHardDriveList.data, (item, index) => {
				hardDriveNameOptions.push({
					value: item.id,
					label: item.qrCode,
				});
			});
			this.setState({
				hardDriveNameOptions,
				hardDriveNameList: response[1].data.vendorHardDriveList.data,
				isHardDriveLoading: false,
			});
		} else {
			return false;
		}
	};

	recordMemoryCardBackup = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Memory Card Backup success!`,
				error: `Failed to Backup Memory Card`,
			},
			{
				theme: 'colored',
				autoClose: 2000,
			},
		);
		if (response[0] == true) {
			if (_.has(response[1], 'errors')) {
				this.setState({
					isMCBackupError: true,
					isMCBackupErrorMessage: response[1].errors[0].message,
				});
			} else {
				this.setState({
					isMCBackupError: false,
					isMCBackupErrorMessage: '',
				});

				if (_.has(this.props, 'onMCBackedUp')) {
					this.props.onMCBackedUp();
				}
				if (_.has(this.props, 'close')) {
					this.props.close();
				}
			}
		} else {
			this.setState({
				isMCBackupError: true,
				isMCBackupErrorMessage: 'Failed to backup Memory Card. Try again.',
			});
		}
	};

	axiosPutFileCallToS3Bucket = async (file, uploadUrl) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let options = {
			headers: {
				'Content-Type': file.type,
			},
		};

		let response = { status: null };
		try {
			response = await axios.put(uploadUrl, file, options);
		} catch (e) {
			return false;
		}
		if (response.status === 200) {
			return true;
		} else {
			return false;
		}
	};

	getFileInfo = async (query, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		try {
			response = await service.query(query, variables, vendorID, usertoken, 'vendors');
		} catch (e) {
			return false;
		}
		if (response[0] == true) {
			return type === null
				? response[1].data.vendorFileUploadStatus
				: response[1].data.branchFileUploadStatus;
		} else {
			return false;
		}
	};

	deleteFile = async (query, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = type === null ? this.props.params.vendorID : this.props.params.workspaceID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					query,
					variables,
					vendorID,
					usertoken,
					type === null ? 'vendors' : null,
				);
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `File Deleted!`,
				error: `Failed to delete file`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			return true;
		} else {
			return false;
		}
	};

	updateProjectNote = async (mutation, variables, type = null) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.mutation(mutation, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let notes = [];
			if (type === 'shoot') {
				notes = response[1].data.updateEventNote.notes;
			} else if (type === 'expense') {
				notes = response[1].data.updateExpenseNote.notes;
			} else if (type === 'payment') {
				notes = response[1].data.updateClientPaymentNote.notes;
			} else if (type === 'deliverable') {
				notes = response[1].data.updateDeliverableNote.notes;
			} else {
				notes = response[1].data.updateProjectNote.notes;
			}
			notes = _.map(notes, (note, indx) => {
				delete note['__typename'];
				return note;
			});
			return notes;
		} else {
			return false;
		}
	};

	getSingleEvent = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			return response[1].data.vendorEvent;
		} else {
			console.log(response);
			return false;
		}
	};

	confirmBackupVerification = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Memory Card backup verified!`,
				error: `Failed to verify memory card backup`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (_.has(this.props, 'onMCBackedUp')) {
				this.props.onMCBackedUp(true);
			}
			if (_.has(this.props, 'close')) {
				this.props.close();
			}
		} else {
		}
	};

	updateMcBackupLogs = async (query, variables, dontShowToast = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		if (dontShowToast === true) {
			response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		} else {
			await toast.promise(
				new Promise(async (resolve, reject) => {
					response = await service.mutation(
						query,
						variables,
						vendorID,
						usertoken,
						'vendors',
					);
					if (response[0] == true) {
						resolve(true);
					} else {
						reject(response[1].message);
					}
				}),
				{
					pending: 'Loading',
					success: `Memory Card backup updated!`,
					error: `Failed to update memory card backup`,
				},
				{
					theme: 'colored',
					autoClose: 500,
				},
			);
		}

		if (response[0] == true) {
			if (_.has(this.props, 'onMCBackedUp')) {
				this.props.onMCBackedUp();
			}
			if (_.has(this.props, 'close')) {
				this.props.close();
			}
		} else {
		}
	};

	updateShoot = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Successfully Flagged!`,
				error: `Failed to update flag`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			this.setState(
				{
					currentViewPage: 1,
					shootList: [],
					isPageLoading: true,
				},
				() => this.fetchMoreShoots(),
			);
		} else {
		}
	};

	getEventsNameList = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			let eventNameOptions = _.map(response[1].data.vendorEventsList.data, (item) => {
				if (item.id !== this.props.activeShootID) {
					return {
						value: item.id,
						label: _.capitalize(item.name),
					};
				}
			});

			this.setState({
				eventNameOptions: _.size(eventNameOptions) > 0 ? _.compact(eventNameOptions) : [],
				events: response[1].data.vendorEventsList.data,
				isEventsListLoading: false,
			});
		} else {
			return false;
		}
	};

	getShoot = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			return response[1].data.vendorEvent;
		} else {
			return false;
		}
	};

	putShoot = async (mutation, variables, getShootMutation, type = null, actionType = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		this.setState({
			disabledBtn: true,
		});
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					mutation,
					variables,
					vendorID,
					usertoken,
					'vendors',
				);
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Shoot ${
					actionType === 'delete' ? 'deleted' : actionType === 'add' ? 'added' : 'updated'
				}!`,
				error: `Failed to ${
					actionType === 'delete' ? 'delete' : actionType === 'add' ? 'add' : 'update'
				} shoot!`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (actionType === 'add') {
				this.props.close();
			}
			if (type === null) {
				if (_.has(this.props, 'shootDetailsUpdated')) {
					this.props.shootDetailsUpdated(response[1]['data']['updateEvent']);
				}

				if (_.has(this, 'shootDetailsUpdated')) {
					this.shootDetailsUpdated(response[1]['data']['updateEvent']);
				}
				if (_.has(this.props, 'close')) {
					this.props.close();
				}
			}
			this.setState({
				disabledBtn: true,
			});
		} else {
			this.setState({
				disabledBtn: false,
			});
		}
	};

	addDeleteShootAdditionalService = async (
		mutation,
		variables,
		type = null,
		actionType = null,
	) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		this.setState({
			disabledBtn: true,
		});
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					mutation,
					variables,
					vendorID,
					usertoken,
					'vendors',
				);
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Successfully ${
					actionType === 'delete' ? 'deleted' : actionType === 'add' ? 'added' : 'updated'
				} ${type} additional service to shoot!`,
				error: `Failed to ${
					actionType === 'delete' ? 'delete' : actionType === 'add' ? 'add' : 'update'
				} ${type} additional service from shoot!`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			if (_.has(this.props, 'shootDetailsUpdated')) {
				this.props.shootDetailsUpdated(actionType === 'add' ? 'add' : null);
			}
			if (_.has(this.props, 'additionalServicesUpdated')) {
				this.props.additionalServicesUpdated();
			}
			if (_.has(this.props, 'close')) {
				this.props.close();
			}

			this.setState({
				disabledBtn: true,
			});
		} else {
			this.setState({
				disabledBtn: false,
			});
		}
	};
	/* assignMemoryCard = async (mutation, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					mutation,
					variables,
					vendorID,
					usertoken,
					'vendors',
				);
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Equipment Remapped!`,
				error: `Failed to remap Equipment`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	}; */

	verifyHddContentQuery = async (mutation, variables, add = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					mutation,
					variables,
					vendorID,
					usertoken,
					'vendors',
				);
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: (add = true ? `HDD Content Added` : `HDD Content Verified!`),
				error: `Failed to ${(add = true ? 'add' : 'verify')}`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			setTimeout(function () {
				window.location.reload();
			}, 500);
		}
	};

	remapEquipment = async (mutation, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					mutation,
					variables,
					vendorID,
					usertoken,
					'vendors',
				);
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `${type === null ? 'Equipment' : 'Memorycard'} remap successful!`,
				error: `Failed to remap ${type === null ? 'equipment' : 'Memorycard'}`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			setTimeout(function () {
				window.location.reload();
			}, 500);
		}
	};
	remapAsset = async (mutation, variables, type = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(
					mutation,
					variables,
					vendorID,
					usertoken,
					'vendors',
				);
				if (response[0] == true) {
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `${type === null ? 'Equipment' : 'Memorycard'} remap successful!`,
				error: `Failed to remap Asset`,
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
		if (response[0] == true) {
			setTimeout(function () {
				window.location.reload();
			}, 500);
		}
	};

	getProjectsList = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				projectsList: response[1].data.vendorsProjects.data,
				isLoading: false,
				totalPages: response[1].data.vendorsProjects.totalPages,
				currentViewPage: response[1].data.vendorsProjects.currentPage,
				lengthOfList: response[1].data.vendorsProjects.totalDocs,
				isPageLoading: false,
			});
		}
	};
	getProjectsList2 = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				projectsList: response[1].data.vendorsProjects.data,
			});
		}
	};
	getAssets = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				assetsList: response[1].data.assets.data,
				isLoading: false,
				totalPages: response[1].data.assets.totalPages,
				currentViewPage: response[1].data.assets.currentPage,
				lengthOfList: response[1].data.assets.totalDocs,
				isPageLoading: false,
			});
		}
	};
	getAssetsMemoryCards = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				assetsList: response[1].data.mcAssetList.data,
				isLoading: false,
				totalPages: response[1].data.mcAssetList.totalPages,
				currentViewPage: response[1].data.mcAssetList.currentPage,
				lengthOfList: response[1].data.mcAssetList.totalDocs,
				isPageLoading: false,
			});
		}
	};
	getAssetsEquipments = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				assetsList: response[1].data.eqAssetList.data,
				isLoading: false,
				totalPages: response[1].data.eqAssetList.totalPages,
				currentViewPage: response[1].data.eqAssetList.currentPage,
				lengthOfList: response[1].data.eqAssetList.totalDocs,
				isPageLoading: false,
			});
		}
	};
	getAssetsSummary = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				assetsSummary: response[1].data.assetsSummary,
			});
		}
	};

	getTenantUsers = async (query) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, {}, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			let assignedToFiltersTemp = [];
			let tempNamesList = [];
			let tempNaneList2 = [];
			let tempNameList3 = [];

			for (let i = 0; i < response[1].data.vendorUsers.length; i++) {
				assignedToFiltersTemp.push({
					key: response[1].data.vendorUsers[i].id,
					name: response[1].data.vendorUsers[i].displayName
						? response[1].data.vendorUsers[i].displayName
						: response[1].data.vendorUsers[i].firstName +
						  ' ' +
						  response[1].data.vendorUsers[i].lastName,
				});
				tempNamesList.push(
					response[1].data.vendorUsers[i].displayName
						? response[1].data.vendorUsers[i].displayName
						: response[1].data.vendorUsers[i].firstName +
								' ' +
								response[1].data.vendorUsers[i].lastName,
				);
				tempNaneList2.push({
					value: response[1].data.vendorUsers[i].id,
					label: response[1].data.vendorUsers[i].displayName
						? response[1].data.vendorUsers[i].displayName
						: response[1].data.vendorUsers[i].firstName +
						  ' ' +
						  response[1].data.vendorUsers[i].lastName,
				});
				tempNameList3.push({
					value: response[1].data.vendorUsers[i].id,
					label:
						response[1].data.vendorUsers[i].firstName +
						' ' +
						response[1].data.vendorUsers[i].lastName,
				});
			}

			this.setState({
				isVendorUsersLoading: false,
				assignedToFilters: assignedToFiltersTemp,
				tenantUserList: [...response[1].data.vendorUsers],
				tenanatuserlist2: [...response[1].data.vendorUsers],
				tenantUsersList: [...response[1].data.vendorUsers],
				namesList: tempNaneList2,
				namesList2: tempNameList3,
				// namesList2: tempNaneList2,
			});
		}
	};
	getMemoryCardSummaryList = async (query, json = {}) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, json, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				memoryCardSummaryList: response[1].data.memoryCardSummary,
			});
		}
	};

	getExpenses = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				expensesList: response[1].data.vendorExpenses,
			});
		}
	};
	getHddLogs = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				isHDDLogsListLoading: false,
				hddLogsList: response[1].data.hddLogs,
			});
		}
	};
	//HDDInfo
	getHddInfo = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] === true) {
			// let newArr = this.state.hardDriveInfoList;
			let newArr = _.has(this.state, 'hardDriveInfoList') ? this.state.hardDriveInfoList : [];

			if (response[1].data.hddInfo !== null) {
				this.setState({
					hddInfo: response[1].data.hddInfo,
				});
				newArr.push({ ...response[1].data.hddInfo });
				this.setState({
					isHDDInfoLoading: false,
					showError: false,
					searchValue: '',
					hardDriveInfoList: newArr,
					calledworkspaceIds: [
						...new Set([
							...(_.has(this.state, 'calledworkspaceIds')
								? this.state.calledworkspaceIds
								: []),
							response[1].data.hddInfo.tenantId,
						]),
					],
				});
			}
			// else if (response[1].data.hddInfo !== null) {
			// this.setState({
			// 	showError: true,

			// });
			// }
		} else {
			this.setState({
				showError: true,
			});
		}
	};
	getMemoryCardLogs = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			if (_.has(response[1].data, 'memoryCard')) {
				this.setState({
					memoryCardInfo: response[1].data.memoryCard,
				});
			}
			if (_.has(response[1].data, 'vendorUsers')) {
				let vendorUsers = [];
				_.forEach(response[1].data.vendorUsers, (user) => {
					user.name = user.displayName
						? user.displayName
						: `${user.firstName ? user.firstName : ''} ${
								user.lastName ? user.lastName : ''
						  }`;

					vendorUsers.push(user);
				});
				this.setState({
					vendorUsers,
				});
			}
			this.setState({
				isLoading: false,
				hasNextPage: response[1].data.mcTransactionLogs.hasNextPage,
				memoryCardLogsList: [
					..._.reverse(response[1].data.mcTransactionLogs.data),
					...this.state.memoryCardLogsList,
				],
				totalPages: response[1].data.mcTransactionLogs.totalPages,
				currentViewPage: response[1].data.mcTransactionLogs.currentPage,
				lengthOfList:
					this.state.lengthOfList + _.size(response[1].data.mcTransactionLogs.data),
				isPageLoading: false,
			});
		}
	};
	getEquipmentsLogs = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			if (_.has(response[1].data, 'equipmentInfo')) {
				this.setState({
					eqInfo: response[1].data.equipmentInfo,
				});
			}
			if (_.has(response[1].data, 'vendorUsers')) {
				let tenantUsers = _.map(response[1].data.vendorUsers, (user) => {
					user.name = user.displayName
						? user.displayName
						: user.firstName + (user.lastName ? ' ' + user.lastName : '');

					return user;
				});
				this.setState({
					tenantUsers: tenantUsers,
				});
			}
			this.setState({
				isLoading: false,
				hasNextPage: response[1].data.eqTransactionLogs.hasNextPage,
				equipmentsLogsList: [
					...this.state.equipmentsLogsList,
					...response[1].data.eqTransactionLogs.data,
				],
				// memoryCardLogsList: response[1].data.eqTransactionLogs.data,
				totalPages: response[1].data.eqTransactionLogs.totalPages,
				currentViewPage: response[1].data.eqTransactionLogs.currentPage,
				// lengthOfList: response[1].data.eqTransactionLogs.totalDocs,
				lengthOfList:
					this.state.lengthOfList + _.size(response[1].data.eqTransactionLogs.data),
				isPageLoading: false,
			});
		}
	};

	// hardDrivesSummary
	getHardDrivesSummary = async (query, variables = {}) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		let response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
		if (response[0] == true) {
			this.setState({
				hardDrivesSummary: response[1].data.hddSummary,
			});
		}
	};
	registerAssets = async (query, variables, assetType) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;

		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					this.setState({
						mcs: [],
						equipments: [],
						type: null,
						size: null,
						manufacturer: null,
						serialNumber: null,
						comment: null,
						branchId: null,
						uploadBatchID: randomize('Aa0', 10),
						files: [],
						notes: null,
					});
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `${
					assetType === 'memorycards' ? 'Memory Cards' : 'Equipments'
				} Registered`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 3000,
			},
		);
		if (response[0] == true) {
			setTimeout(() => {
				window.location.reload();
			}, 2000);
		}
	};

	whatsAppNotifyTeamMembers = async (query, variables) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;

		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					this.setState({
						showNotifyTeamMemberModal: false,
					});
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `Notified!!!`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	};

	getShootsCumulatedData = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			if (_.has(response[1].data, 'vendorInfo')) {
				let workspacesFilters = [];
				let workspacesOptions = [];
				workspacesFilters = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
					return {
						key: item._id,
						name: item.workspaceId,
					};
				});
				workspacesOptions = _.map(response[1].data.vendorInfo.associatedTenants, (item) => {
					return {
						value: item._id,
						label: item.workspaceId,
					};
				});

				this.setState({
					workspacesFilters,
					workspacesOptions,
					vendorInfo: response[1].data.vendorInfo,
				});
			}

			let shootsData = response[1].data.vendorEventsList.data;
			let shootsList = {};
			_.map(shootsData, (shoot, key) => {
				let customKey = shoot.date + '_' + shoot.tenantId;

				let candidPhoto = [];
				let traditionalPhoto = [];
				let candidVideo = [];
				let traditionalVideo = [];

				_.forEach(shoot.crewNew, (crew, index) => {
					if (crew.isCustomUser !== true) {
						_.forEach(crew.roles, (roles, inx) => {
							if (roles.role === 'photographer' && roles.subRole === 'candid') {
								candidPhoto.push({
									role: 'photographer',
									subRole: 'candid',
									userId: crew.userId,
									isManager: crew.isManager,
								});
							} else if (
								roles.role === 'photographer' &&
								roles.subRole === 'traditional'
							) {
								traditionalPhoto.push({
									role: 'photographer',
									subRole: 'traditional',
									userId: crew.userId,
									isManager: crew.isManager,
								});
							} else if (
								roles.role === 'cinematographer' &&
								roles.subRole === 'candid'
							) {
								candidVideo.push({
									role: 'cinematographer',
									subRole: 'candid',
									userId: crew.userId,
									isManager: crew.isManager,
								});
							} else if (
								roles.role === 'cinematographer' &&
								roles.subRole === 'traditional'
							) {
								traditionalVideo.push({
									role: 'cinematographer',
									subRole: 'traditional',
									userId: crew.userId,
									isManager: crew.isManager,
								});
							}
						});
					}
				});

				let shooterCountJson = {
					candidPhoto: _.size(candidPhoto),
					traditionalPhoto: _.size(traditionalPhoto),
					candidVideo: _.size(candidVideo),
					traditionalVideo: _.size(traditionalVideo),
				};

				if (_.has(shootsList, customKey)) {
					if (shoot.reportingTime == null || shoot.reportingTime == '') {
						shootsList[customKey] = {
							...shootsList[customKey],
							shootsCount: shootsList[customKey]['shootsCount'] + 1,
							noTimeShooterCount: {
								candidPhoto:
									shootsList[customKey]['noTimeShooterCount']['candidPhoto'] +
									shooterCountJson['candidPhoto'],
								traditionalPhoto:
									shootsList[customKey]['noTimeShooterCount'][
										'traditionalPhoto'
									] + shooterCountJson['traditionalPhoto'],
								candidVideo:
									shootsList[customKey]['noTimeShooterCount']['candidVideo'] +
									shooterCountJson['candidVideo'],
								traditionalVideo:
									shootsList[customKey]['noTimeShooterCount'][
										'traditionalVideo'
									] + shooterCountJson['traditionalVideo'],
							},
						};
					} else if (shoot.reportingTime.includes('AM')) {
						shootsList[customKey] = {
							...shootsList[customKey],
							shootsCount: shootsList[customKey]['shootsCount'] + 1,
							amShooterCount: {
								candidPhoto:
									shootsList[customKey]['amShooterCount']['candidPhoto'] +
									shooterCountJson['candidPhoto'],
								traditionalPhoto:
									shootsList[customKey]['amShooterCount']['traditionalPhoto'] +
									shooterCountJson['traditionalPhoto'],
								candidVideo:
									shootsList[customKey]['amShooterCount']['candidVideo'] +
									shooterCountJson['candidVideo'],
								traditionalVideo:
									shootsList[customKey]['amShooterCount']['traditionalVideo'] +
									shooterCountJson['traditionalVideo'],
							},
						};
					} else if (shoot.reportingTime.includes('PM')) {
						shootsList[customKey] = {
							...shootsList[customKey],
							shootsCount: shootsList[customKey]['shootsCount'] + 1,
							pmShooterCount: {
								candidPhoto:
									shootsList[customKey]['pmShooterCount']['candidPhoto'] +
									shooterCountJson['candidPhoto'],
								traditionalPhoto:
									shootsList[customKey]['pmShooterCount']['traditionalPhoto'] +
									shooterCountJson['traditionalPhoto'],
								candidVideo:
									shootsList[customKey]['pmShooterCount']['candidVideo'] +
									shooterCountJson['candidVideo'],
								traditionalVideo:
									shootsList[customKey]['pmShooterCount']['traditionalVideo'] +
									shooterCountJson['traditionalVideo'],
							},
						};
					}
				} else {
					shootsList[customKey] = {
						date: shoot.date,
						tenantId: shoot.tenantId,
						shootsCount: 1,
						amShooterCount: {
							candidPhoto: 0,
							traditionalPhoto: 0,
							candidVideo: 0,
							traditionalVideo: 0,
						},
						pmShooterCount: {
							candidPhoto: 0,
							traditionalPhoto: 0,
							candidVideo: 0,
							traditionalVideo: 0,
						},
						noTimeShooterCount: {
							candidPhoto: 0,
							traditionalPhoto: 0,
							candidVideo: 0,
							traditionalVideo: 0,
						},
					};

					if (shoot.reportingTime == null || shoot.reportingTime == '') {
						shootsList[customKey] = {
							...shootsList[customKey],
							noTimeShooterCount: shooterCountJson,
						};
					} else if (shoot.reportingTime.includes('AM')) {
						shootsList[customKey] = {
							...shootsList[customKey],
							amShooterCount: shooterCountJson,
						};
					} else if (shoot.reportingTime.includes('PM')) {
						shootsList[customKey] = {
							...shootsList[customKey],
							pmShooterCount: shooterCountJson,
						};
					}
				}
			});

			this.setState({
				shootsList: { ...this.state.shootsList, ...shootsList },
				totalPages: response[1].data.vendorEventsList.totalPages,
				page: response[1].data.vendorEventsList.currentPage,
				lengthOfList:
					this.state.lengthOfList + _.size(response[1].data.vendorEventsList.data), //response[1].data.vendorEventsList.totalDocs
				hasNextPage: response[1].data.vendorEventsList.hasNextPage,
				isLoading: false,
			});
		}
	};

	getVendorUsers = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			this.setState({
				isLoading: false,
				vendorUsers: response[1].data.vendorsTenantUsers,
			});
		} else {
			console.log(response[1]);
		}
	};
	generateRandomHexColor = () => {
		const letters = '0123456789ABCDEF';
		let color = '#';
		for (let i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	};
	getFlags = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			// let resArray = [];
			const priorityOrder = ['high', 'medium', 'low'];
			const priorityColors = {
				high: '#EC532A', // Red
				medium: '#F3AF3D', // Orange
				low: '#BF8EFF', // Purple
			};
			const sortedData = _.orderBy(
				response[1].data.moduleFlags,
				[
					(item) => priorityOrder.indexOf(item.priority), // First sort by priority order
					'activeFlagsCount', // Then sort by activeFlagsCount in descending order
				],
				['asc', 'desc'],
			);
			const dataWithColor = sortedData.map((item) => ({
				...item,
				color: priorityColors[item.priority],
			}));

			this.setState({
				// rank: response[1].data.shooterRank.rank,
				resArray: dataWithColor,
			});
		} else {
			console.log(response[1]);
		}
	};
	getTaskFlags = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			// let resArray = [];
			let pendingCount = 0;

			let taskFlags = response[1].data.taskDefaultFilters;
			const colorMap = {
				todo: '#9F4DB7',
				inProgress: '#5383EC',
				inReview: '#8EE2C7',
				done: '#479A5F',
			};

			const statusOrder = ['todo', 'inProgress', 'inReview', 'done'];

			// const statusFlags = taskFlags.statusFilters
			// 	.filter((filter) => statusOrder.includes(filter.status))
			// 	.map((filter) => {
			// 		return {
			// 			status: filter.status,
			// 			color: colorMap[filter.status],
			// 			count: filter.count,
			// 		};
			// 	});
			const statusFlags = statusOrder.map((status) => {
				const filter = taskFlags.statusFilters.find((filter) => filter.status === status);

				if (filter) {
					return {
						status: filter.status,
						color: colorMap[filter.status],
						count: filter.count,
					};
				} else {
					return {
						status: status,
						color: colorMap[status],
						count: 0,
					};
				}
			});

			this.setState({
				taskFlags,
				statusFlags,
			});
		} else {
			console.log(response[1]);
		}
	};
	getExpensesNew = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			const output = [];
			const thisMonthStartDate = moment(this.state.startDate, 'YYYYMMDD');
			const currentMonth = thisMonthStartDate.clone();
			const threeMonthsAgo = thisMonthStartDate.clone().subtract(3, 'months');
			while (currentMonth.isAfter(threeMonthsAgo, 'month')) {
				const monthValue = parseInt(currentMonth.format('YYYYMM'), 10);
				const foundMonth = response[1].data.tenantUserExpenseActivity.pastMonths.find(
					(item) => item.month === monthValue,
				);

				if (foundMonth) {
					output.push({
						totalExpense: foundMonth.totalExpense,
						month: foundMonth.month,
					});
				} else {
					output.push({ totalExpense: 0, month: monthValue });
				}

				currentMonth.subtract(1, 'months');
			}
			output.sort((a, b) => a.month - b.month);
			this.setState({
				employeeExpenseDetails: response[1].data.tenantUserExpenseActivity,
				expenseGraphData: output,
			});
		} else {
			console.log(response[1]);
		}
	};
	getRank = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			this.setState({
				rank: response[1].data.shooterRank.rank,
			});
		} else {
			console.log(response[1]);
		}
	};
	getProductivity = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			const output = [];
			const output2 = [];
			const output4 = [];
			const thisMonthStartDate = moment(this.state.startDate, 'YYYYMMDD');
			// const thisMonthStartDate = moment('20230601', 'YYYYMMDD');
			const currentMonth = thisMonthStartDate.clone();
			const threeMonthsAgo = thisMonthStartDate.clone().subtract(3, 'months');
			// shootDays;
			while (currentMonth.isAfter(threeMonthsAgo, 'month')) {
				const monthValue = parseInt(currentMonth.format('YYYYMM'), 10);
				const foundMonth = response[1].data.tenantUserEventActivity.pastMonths.find(
					(item) => item.month === monthValue,
				);
				const foundMonth2 = response[1].data.tenantUserEventActivity.shootDays.find(
					(item) => item.month === monthValue,
				);
				const foundMonth3 = response[1].data.tenantUserEventActivity.feedBack.find(
					(item) => item.month === monthValue,
				);

				if (foundMonth) {
					output.push({ totalEvents: foundMonth.totalEvents, month: foundMonth.month });
				} else {
					output.push({ totalEvents: 0, month: monthValue });
				}
				if (foundMonth2) {
					output2.push({ shootDays: foundMonth2.shootDays, month: foundMonth2.month });
				} else {
					output2.push({ shootDays: 0, month: monthValue });
				}
				if (foundMonth3) {
					output4.push({
						totalFeedBacks: foundMonth3.totalFeedBacks,
						month: foundMonth3.month,
					});
				} else {
					output4.push({ totalFeedBacks: 0, month: monthValue });
				}

				currentMonth.subtract(1, 'months');
			}
			output.sort((a, b) => a.month - b.month);
			output2.sort((a, b) => a.month - b.month);
			output4.sort((a, b) => a.month - b.month);
			// const thisMonthStartDate = moment(this.state.startDate, 'YYYYMMDD'); // Assuming the current month is June 2023

			const output3 = [];
			const daysInMonth = thisMonthStartDate.daysInMonth(); // Get the total days in the current month

			for (let i = 1; i <= daysInMonth; i++) {
				const currentDateValue = parseInt(
					thisMonthStartDate.format('YYYYMM') + i.toString().padStart(2, '0'),
					10,
				);
				const foundDate = response[1].data.tenantUserEventActivity.currentMonth.find(
					(item) => item.date === currentDateValue,
				);

				if (foundDate) {
					output3.push({
						totalEvents: foundDate.totalEvents,
						date: foundDate.date,
					});
				} else {
					output3.push({ totalEvents: 0, date: currentDateValue });
				}
			}

			output3.sort((a, b) => a.date - b.date);
			let totEventCount = 0;
			let eventsData = [];
			for (let i = 0; i < _.size(response[1].data.tenantUserEventActivity.project); i++) {
				totEventCount += response[1].data.tenantUserEventActivity.project[i].eventsCount;
				eventsData.push({
					label: response[1].data.tenantUserEventActivity.project[i].title,
					value: response[1].data.tenantUserEventActivity.project[i].eventsCount,
				});
			}
			const colorsArray = Array.from({ length: 10 }, () => this.generateRandomHexColor());
			const chartData = {
				labels: eventsData.map((item) => item.label),
				datasets: [
					{
						data: eventsData.map((item) => item.value),
						backgroundColor: eventsData.map((el, i) => colorsArray[i]), // Generate a random color for each data point
						hoverBackgroundColor: eventsData.map((el, i) => colorsArray[i]), // Generate a random hover color for each data point
					},
				],
			};

			this.setState({
				userProductivityDetails: response[1].data.tenantUserEventActivity,
				shootsGraphData: output,
				shoootDaysGraphData: output2,
				currentMonthShootData: output3,
				feedBackGraphData: output4,
				eventsData: eventsData,
				chartData,
			});
		} else {
			console.log(response[1]);
		}
	};

	handleInviteVendorUser = async (query, variables, actionType = null) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;

		var response = [];
		response[0] = false;
		await toast.promise(
			new Promise(async (resolve, reject) => {
				response = await service.mutation(query, variables, vendorID, usertoken, 'vendors');
				if (response[0] == true) {
					this.setState({
						showCreateUserModal: false,
					});
					this.afterUpdateVendorUser();
					resolve(true);
				} else {
					reject(response[1].message);
				}
			}),
			{
				pending: 'Loading',
				success: `User ${variables.email} ${
					actionType === 'updated'
						? 'updated'
						: actionType === 'remove'
						? 'removed'
						: 'invited'
				} successfully`,
				error: {
					render({ data }) {
						return data;
					},
				},
			},
			{
				theme: 'colored',
				autoClose: 500,
			},
		);
	};

	getMcLogsForFullView = async (query, variables) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			this.setState({
				mcLogs: response[1].data.mcTransactionLogs.data,
			});
			return response[1].data.mcTransactionLogs.data;
		} else {
			return false;
			console.log(response[1]);
		}
	};

	getMonthlyOverview = async (query, variables, isFirstLoad = null) => {
		//Have to Update this
		this.checkUserLoggedIn();

		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response = await service.query(query, variables, vendorID, usertoken, 'vendors');

		if (response[0] == true) {
			let shootsLineGraphData = _.cloneDeep(this.state.shootsLineGraphData);
			let expensesLineGraphData = _.cloneDeep(this.state.expensesLineGraphData);
			let assignedLineGraphData = _.cloneDeep(this.state.assignedLineGraphData);
			let requirementLineGraphData = _.cloneDeep(this.state.requirementLineGraphData);
			let ledLineGraphData = _.cloneDeep(this.state.ledLineGraphData);
			let webLiveLineGraphData = _.cloneDeep(this.state.webLiveLineGraphData);
			let mcLineGraphData = _.cloneDeep(this.state.mcLineGraphData);
			let eventTypeFilters = [];

			shootsLineGraphData.datasets[0].data = [];

			expensesLineGraphData.datasets[0].data = [];
			expensesLineGraphData.datasets[1].data = [];
			expensesLineGraphData.datasets[2].data = [];

			assignedLineGraphData.datasets[0].data = [];
			assignedLineGraphData.datasets[1].data = [];

			requirementLineGraphData.datasets[0].data = [];
			requirementLineGraphData.datasets[1].data = [];
			requirementLineGraphData.datasets[2].data = [];
			requirementLineGraphData.datasets[3].data = [];

			ledLineGraphData.datasets[0].data = [];

			webLiveLineGraphData.datasets[0].data = [];

			mcLineGraphData.datasets[0].data = [];
			mcLineGraphData.datasets[1].data = [];
			mcLineGraphData.datasets[2].data = [];
			mcLineGraphData.datasets[3].data = [];
			mcLineGraphData.datasets[4].data = [];
			mcLineGraphData.datasets[5].data = [];

			_.forEach(response[1].data.monthlyOverview.events, (event, inx) => {
				let foundIndex = -1;
				let type = event.eventType;
				foundIndex = _.findIndex(eventTypeFilters, { key: type });
				if (foundIndex === -1) {
					eventTypeFilters.push({
						key: type,
						name: type,
					});
				}
			});

			this.setState({
				eventTypeFilters,
			});

			let filteredEvents;

			if (isFirstLoad === true) {
				filteredEvents =
					this.state.eventTypeActiveFilter !== ''
						? _.filter(response[1].data.monthlyOverview.events, {
								eventType: this.state.eventTypeActiveFilter,
						  })
						: response[1].data.monthlyOverview.events;
			} else {
				filteredEvents = response[1].data.monthlyOverview.events;
				this.setState({
					eventTypeActiveFilter: '',
				});
			}

			_.forEach(
				new Array(moment().month(this.state.monthActiveFilter).daysInMonth()).fill(0),
				(date, index) => {
					let day = parseInt(
						moment()
							.month(this.state.monthActiveFilter)
							.date(index + 1)
							.format('YYYYMMDD'),
					);

					let found = _.filter(filteredEvents, { date: day });

					if (_.size(found) > 0) {
						_.forEach(found, (item, inx) => {
							if (inx === 0) {
								shootsLineGraphData.datasets[0].data.push(item.totalEvents);
							} else {
								shootsLineGraphData.datasets[0].data[index] += item.totalEvents;
							}
						});
					} else {
						shootsLineGraphData.datasets[0].data.push(0);
					}

					found = undefined;
					found = _.find(response[1].data.monthlyOverview.expenses, { date: day });

					if (found) {
						expensesLineGraphData.datasets[0].data.push(
							found.approvedExpense + found.unApprovedExpense,
						);
						expensesLineGraphData.datasets[1].data.push(found.approvedExpense);
						expensesLineGraphData.datasets[2].data.push(found.unApprovedExpense);
					} else {
						expensesLineGraphData.datasets[0].data.push(0);
						expensesLineGraphData.datasets[1].data.push(0);
						expensesLineGraphData.datasets[2].data.push(0);
					}

					found = undefined;
					found = _.find(response[1].data.monthlyOverview.crew, { date: day });

					if (found) {
						assignedLineGraphData.datasets[0].data.push(found.assignedCrewCount);
						assignedLineGraphData.datasets[1].data.push(found.unAssignedCrewCount);
					} else {
						assignedLineGraphData.datasets[0].data.push(0);
						assignedLineGraphData.datasets[1].data.push(0);
					}

					found = undefined;
					found = _.find(response[1].data.monthlyOverview.requirement, { date: day });

					if (found) {
						let found2 = undefined;
						found2 = _.find(found.roles, { ...this.state.crewMapdata['CP'] });
						if (found2) {
							requirementLineGraphData.datasets[0].data.push(found2.count);
						} else {
							requirementLineGraphData.datasets[0].data.push(0);
						}

						found2 = undefined;
						found2 = _.find(found.roles, { ...this.state.crewMapdata['TP'] });
						if (found2) {
							requirementLineGraphData.datasets[1].data.push(found2.count);
						} else {
							requirementLineGraphData.datasets[1].data.push(0);
						}

						found2 = undefined;
						found2 = _.find(found.roles, { ...this.state.crewMapdata['CV'] });
						if (found2) {
							requirementLineGraphData.datasets[2].data.push(found2.count);
						} else {
							requirementLineGraphData.datasets[2].data.push(0);
						}

						found2 = undefined;
						found2 = _.find(found.roles, { ...this.state.crewMapdata['TV'] });
						if (found2) {
							requirementLineGraphData.datasets[3].data.push(found2.count);
						} else {
							requirementLineGraphData.datasets[3].data.push(0);
						}
					} else {
						requirementLineGraphData.datasets[0].data.push(0);
						requirementLineGraphData.datasets[1].data.push(0);
						requirementLineGraphData.datasets[2].data.push(0);
						requirementLineGraphData.datasets[3].data.push(0);
					}

					found = undefined;
					found = _.find(response[1].data.monthlyOverview.additionalServices, {
						date: day,
						type: 'led',
					});

					if (found) {
						ledLineGraphData.datasets[0].data.push(found.count);
					} else {
						ledLineGraphData.datasets[0].data.push(0);
					}

					found = undefined;
					found = _.find(response[1].data.monthlyOverview.additionalServices, {
						date: day,
						type: 'webLive',
					});

					if (found) {
						webLiveLineGraphData.datasets[0].data.push(found.count);
					} else {
						webLiveLineGraphData.datasets[0].data.push(0);
					}

					if ((_.has(response[1].data), 'mcMonthlySummary')) {
						found = undefined;
						found = _.find(response[1].data.mcMonthlySummary, { date: day });

						if (found) {
							let found2 = undefined;
							found2 = _.find(found.mcDetails, { status: 'assigned' });
							if (found2) {
								mcLineGraphData.datasets[0].data.push(found2.count);
							} else {
								mcLineGraphData.datasets[0].data.push(0);
							}

							found2 = undefined;
							found2 = _.find(found.mcDetails, { status: 'registered' });
							if (found2) {
								mcLineGraphData.datasets[1].data.push(found2.count);
							} else {
								mcLineGraphData.datasets[1].data.push(0);
							}

							found2 = undefined;
							found2 = _.find(found.mcDetails, { status: 'copied' });
							if (found2) {
								mcLineGraphData.datasets[2].data.push(found2.count);
							} else {
								mcLineGraphData.datasets[2].data.push(0);
							}

							found2 = undefined;
							found2 = _.find(found.mcDetails, { status: 'verified' });
							if (found2) {
								mcLineGraphData.datasets[3].data.push(found2.count);
							} else {
								mcLineGraphData.datasets[3].data.push(0);
							}

							found2 = undefined;
							found2 = _.find(found.mcDetails, { status: 'released' });
							if (found2) {
								mcLineGraphData.datasets[4].data.push(found2.count);
							} else {
								mcLineGraphData.datasets[4].data.push(0);
							}

							found2 = undefined;
							found2 = _.find(found.mcDetails, { status: 'received' });
							if (found2) {
								mcLineGraphData.datasets[5].data.push(found2.count);
							} else {
								mcLineGraphData.datasets[5].data.push(0);
							}
						} else {
							mcLineGraphData.datasets[0].data.push(0);
							mcLineGraphData.datasets[1].data.push(0);
							mcLineGraphData.datasets[2].data.push(0);
							mcLineGraphData.datasets[3].data.push(0);
							mcLineGraphData.datasets[4].data.push(0);
							mcLineGraphData.datasets[5].data.push(0);
						}
					}
				},
			);

			this.setState({
				monthlyOverview: response[1].data.monthlyOverview,
				shootsLineGraphData,
				expensesLineGraphData,
				assignedLineGraphData,
				requirementLineGraphData,
				ledLineGraphData,
				webLiveLineGraphData,
				mcLineGraphData,
				isLoading: false,
				isPageLoading: false,
			});
		} else {
			console.log(response[1]);
		}
	};
}

export default ProjectsGraphQl;
